let lastScrollTop = 0;
window.addEventListener("scroll", () => {
	const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

	if (currentScroll > lastScrollTop) {
		document.body.classList.remove("scroll-up");
		document.body.classList.add("scroll-down");
	} else if (currentScroll < lastScrollTop) {
		document.body.classList.remove("scroll-down");
		document.body.classList.add("scroll-up");
	}

	headerFixed();

	lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
});

function headerFixed(refresh = false) {
	const header = document.querySelector('.header-pac, .header-prize, .header-fgap');
	const headerModal = document.querySelector('.header-pac-modal, .header-prize-modal, .header-fgap-modal');
	if (header) {
		if (window.scrollY > 0) {
			if (header.classList.contains('sticky')) {
				header.classList.add('sticky');
			}
		} else {
			header.classList.remove('sticky');
		}
		if (!headerModal.classList.contains("show")) {
			if ((window.scrollY > lastScrollTop || refresh) && window.scrollY > header.clientHeight) {
				const scrollPos = parseInt(header.clientHeight);
				header.classList.remove("show");
				header.style.transform = `translateY(-${scrollPos}px)`;
			} else {
				header.classList.add("show");
				header.style.transform = "";
			}
		}
	}
}
headerFixed();

/* - - - - - - - - - - - - - -       scroll to id       - - - - - - - - - - - - - - - */
function scrollToHashTarget(hash, speed = 500) {
	if (!hash || hash.length <= 1 || !$(hash).length) {
		return;
	}

	const top = $(window).scrollTop();
	const posTop = $(hash).offset().top - 24;
	const headerHeight = $('.header-pac, .header-prize, .header-fgap').length ? $('.header-pac, .header-prize, .header-fgap').innerHeight() : 0;
	const scrollTo = top > posTop ? posTop - headerHeight : posTop;

	$('html, body').animate({scrollTop: scrollTo}, speed);
}

function scrollToId(id = false, speed = 250) {
	if (!id) {
		return;
	}

	scrollToHashTarget(`#${id}`, speed);
}

/* - - - - - - - - - - - - - -       generate random string       - - - - - - - - - - - - - - - */
function generateRandomString(length) {
	const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
	let result = '';
	for (let i = 0; i < length; i++) {
		let randomIndex = '';
		if (i) {
			randomIndex = Math.floor(Math.random() * chars.length);
		} else {
			randomIndex = Math.floor(Math.random() * [...chars].filter(char => /[a-z]/i.test(char)).join('').length);
		}
		result += chars[randomIndex];
	}
	return result;
}

/* - - - - - - - - - - - - - -       add image       - - - - - - - - - - - - - - - */
function addImage($uploadFile, id, file, fileSrc) {
	const fileImg = fileSrc ? `<img src="${fileSrc}" alt="${file.name}">` : '<span class="icon icon-i-loading"></span>';
	const fileTpl = `
			<div id="file-${id}" class="form-upload__file">
				<div class="form-upload__file-img">${fileImg}</div>
				<div class="form-upload__file-title">${file.name}</div>
				<div class="form-upload__file-remove js-remove-file" data-id="${id}"><span class="icon icon-i-close"></span></div>
			</div>
		`;
	const $uploadList = $uploadFile.find('.form-upload__list');
	$uploadList.append(fileTpl);
}

function validateInputField($input) {
	const $parent = $input.closest('.form-group');
	const value = $input.val().trim();
	const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
	const maxCount = $input.data('count');
	let hasError = false;

	const isValidUrlValue = (urlValue) => {
		if (urlValue === '') {
			return true;
		}

		if (/\s/.test(urlValue)) {
			return false;
		}

		const normalizedUrl = /^https?:\/\//i.test(urlValue) ? urlValue : `https://${urlValue}`;

		try {
			const url = new URL(normalizedUrl);
			return url.hostname.includes('.');
		} catch (error) {
			return false;
		}
	};

	if ($input.is('[data-required]') && value === '') {
		hasError = true;
	} else if ($input.attr('type') === 'email' && value !== '' && !emailRegex.test(value)) {
		hasError = true;
	} else if ($input.is('[data-url]') && value !== '' && !isValidUrlValue(value)) {
		hasError = true;
	} else if (maxCount && $input.val().length > maxCount) {
		hasError = true;
	}

	if ($parent.length) {
		$parent.toggleClass('has-error', hasError);
	}
}

/* - - - - - - - - - - - - - -       toggle additional field       - - - - - - - - - - - - - - - */
function toggleAdditionalField() {
	const $additional = $('.form-additional');
	$additional.each(function() {
		const $additionalField = $(this).find('[type="checkbox"][data-additional], [type="radio"][data-additional]');
		const $additionalBox = $(this).find('div[data-additional]');
		if ($additionalField.length && $additionalField.prop('checked')) {
			$additionalBox.removeClass("hidden");
		} else {
			$additionalBox.addClass("hidden");
		}
	});
}

/* - - - - - - - - - - - - - -       init events grid       - - - - - - - - - - - - - - - */
function initEventsGrid() {
	// const fontSize = parseInt($('html').css('font-size'));
	// console.log(fontSize)
	const $eventsGrid = $('.js-events-grid').masonry({
		gutter: 0,
		itemSelector: '.events-box',
		stamp: '.events-stamp',
		horizontalOrder: true
	});
	$eventsGrid.imagesLoaded().progress( function() {
		$eventsGrid.masonry('layout');
	});
}

/* - - - - - - - - - - - - - -       init works grid       - - - - - - - - - - - - - - - */
function initWorksGrid() {
	const $eventsGrid = $('.js-works-grid').masonry({
		gutter: 0,
		itemSelector: '.works-tabs__box-card',
		stamp: '.works-tabs__box-stamp',
		horizontalOrder: true
	});
	$eventsGrid.imagesLoaded().progress( function() {
		$eventsGrid.masonry('layout');
	});
}

/* - - - - - - - - - - - - - -       init research archive grid       - - - - - - - - - - - - - - - */
function initResearchArchiveGrid() {
	const $researchArchiveGrid = $('.js-research-archive-grid').masonry({
		gutter: 0,
		itemSelector: '.research-archive__group',
		stamp: '.events-stamp',
		horizontalOrder: true
	});
	$researchArchiveGrid.imagesLoaded().progress( function() {
		$researchArchiveGrid.masonry('layout');
	});
}

/* - - - - - - - - - - - - - -       init research publication grid       - - - - - - - - - - - - - - - */
function initResearchPublicationGrid() {
	const $researchPublicationGrid = $('.js-research-publications-masonry').masonry({
		gutter: 0,
		itemSelector: '.research-publications__box',
		stamp: '.research-publications__stamp',
		horizontalOrder: true
	});
	$researchPublicationGrid.imagesLoaded().progress( function() {
		$researchPublicationGrid.masonry('layout');
	});
}

/* - - - - - - - - - - - - - -       init research publication grid       - - - - - - - - - - - - - - - */
function initResearchInstitutionGrid() {
	const $researchInstitutionGrid = $('.js-research-institutions-masonry').masonry({
		gutter: 0,
		itemSelector: '.research-institutions__box',
		stamp: '.research-institutions__stamp',
		horizontalOrder: true
	});
	$researchInstitutionGrid.imagesLoaded().progress( function() {
		$researchInstitutionGrid.masonry('layout');
	});
}

/* - - - - - - - - - - - - - -       init prize works grid       - - - - - - - - - - - - - - - */
function initPrizeWorksGrid() {
	const $prizeWorksGrid = $('.js-prize-works-grid').masonry({
		gutter: 0,
		itemSelector: '.prize-works__box',
		stamp: '.prize-works__stamp',
		horizontalOrder: true
	});
	$prizeWorksGrid.imagesLoaded().progress( function() {
		$prizeWorksGrid.masonry('layout');
	});
}

/* - - - - - - - - - - - - - -       progress filled submission       - - - - - - - - - - - - - - - */
function progressFilledSubmission() {
	$('.accordion-box').each(function() {
		const $accordionBox = $(this);
		const $accordionCounter = $accordionBox.find('.accordion-box__counter');
		const $accordionFieldList = $accordionBox.find('.form-group');
		const $accordionCheckboxList = $accordionBox.find('.form-checkbox');
		const $accordionUploadList = $accordionBox.find('.form-upload');
		const index = $accordionBox.index();
		const tab = $accordionBox.closest('.tabs-box').data('tab');
		const countField = $accordionFieldList.length + $accordionCheckboxList.length + $accordionUploadList.length;
		const $submissionSidebar = $('.submission-sidebar__step');
		const $submissionStep = $submissionSidebar.find(`.submission-sidebar__step-group[data-tab="${tab}"] .submission-sidebar__step-box`).eq(index);
		let countFilledField = 0;
		let progress = 0;
		$accordionFieldList.each((i, item) => {
			if ($(item).find('input:not(.iti__search-input), textarea, select').val() !== '') {
				countFilledField += 1;
			}
		});
		$accordionCheckboxList.each((i, item) => {
			let isChecked = false;
			if ($(item).find('input').is(':checked')) {
				isChecked = true;
			}
			if (isChecked) {
				countFilledField += 1;
			}
		});
		$accordionUploadList.each((i, item) => {
			if ($(item).find('.form-upload__file:not(.error)').length) {
				countFilledField += 1;
			}
			// if ($(item).find('input').val() !== '') {
			// 	countFilledField += 1;
			// }
		});
		progress = countFilledField / countField * 100;
		$accordionCounter.text(`${countFilledField}/${countField}`);
		$submissionStep.find('.submission-sidebar__step-progress-bar').css('width', `${progress}%`);
		$submissionStep.find('.submission-sidebar__step-progress-count').text(`${countFilledField}/${countField}`);
	});
}

/* - - - - - - - - - - - - - -       get cookie       - - - - - - - - - - - - - - - */
function showCookieModal() {
	const str = document.cookie.split( '; ' );
	const cookie = {};
	for ( let i = 0; i < str.length; i++ ) {
		const cur = str[ i ].split( '=' );
		cookie[ cur[ 0 ] ] = cur[ 1 ];
	}
	if ( cookie.cookieAccept !== 'true' ) {
		setTimeout( function() {
			$( '.cookie' ).addClass( 'show' );
			// $('.overflow').addClass('show');
		}, 10000 );
	} else {
		$( '.cookie' ).removeClass( 'show' );
	}
}

function checkPassword(password) {
	const regexPassword = new Array();
	regexPassword.push('[A-Z]');
	regexPassword.push('[a-z]');
	regexPassword.push('[0-9]');
	regexPassword.push('^.{8,16}$');
	// regexPassword.push('[$@!%*#?&]');
	const step = parseFloat(100 / regexPassword.length);
	let successful = 0;
	let percent = 0;
	let mess = '';
	for (let i = 0; i < regexPassword.length; i++) {
		if (new RegExp(regexPassword[i]).test(password)) {
			successful++;
		}
	}
	switch (successful) {
		case 0:
			// console.log('None');
			mess = 'None';
			break;
		case 1:
			// console.log('Weak');
			mess = 'Weak';
			break;
		case 2:
			// console.log('Medium');
			mess = 'Medium';
			break;
		case 3:
			// console.log('Strong');
			mess = 'Strong';
			break;
		case 4:
			// console.log('Very Strong);
			mess = 'Very Strong';
			break;
	}
	percent = step * successful;
	// console.log(`${percent} - ${mess}`);
}

/* - - - - - - - - - - - - - -       scroll to with scrollbar       - - - - - - - - - - - - - - - */
function scrollToError() {
	let headerHeight = 0;
	if ($('.header-fgap').length) {
		headerHeight = $('.header-fgap').innerHeight();
	}
	if ($('.header-pac, .header-prize').length) {
		headerHeight = $('.header-pac, .header-prize').innerHeight();
	}
	if ($('.has-error').length) {
		const posTop = $('.has-error').offset().top - headerHeight - 24;
		$('html, body').animate({scrollTop: posTop}, 250);
	}
}

/* - - - - - - - - - - - - - -       scroll to without scrollbar       - - - - - - - - - - - - - - - */
// function scrollToError() {
// 	let headerHeight = 0;
// 	if ($('.header-fgap').length) {
// 		headerHeight = $('.header-fgap').innerHeight();
// 	}
// 	if ($('.header-pac, .header-prize').length) {
// 		headerHeight = $('.header-pac, .header-prize').innerHeight();
// 	}
// 	if ($('.has-error').length) {
// 		const posTop = $(document).innerHeight() - $(window).innerHeight() - headerHeight - Math.abs($('.has-error').offset().top) - 24;
// 		$('html, body').animate({scrollTop: posTop}, 250);
// 	}
// }

/* - - - - - - - - - - - - - -       extract youtube video id       - - - - - - - - - - - - - - - */
function extractVideoId(url) {
	const regex = /(?:\?v=|\/embed\/|\.be\/)([a-zA-Z0-9_-]{11})/;
	const match = url.match(regex);
	return match ? match[1] : null;
}

/* - - - - - - - - - - - - - -       set youtube thumbnail       - - - - - - - - - - - - - - - */
function setYoutubeThumbnail(videoBox) {
	if (videoBox.find('iframe').length) {
		const videoSrc = videoBox.find('iframe').attr('src');
		const videoId = extractVideoId(videoSrc);
		if (!videoId) {
			alert('Unable to find video ID.');
			return;
		}

		const videoPreview = videoBox.find('iframe').attr('data-preview-url');

		const srcset = videoPreview || `https://img.youtube.com/vi/${videoId}/sddefault.jpg`;

		// change maxresdefault to sddefault
		const thumbnailTpl = `
				<picture>
					<source srcset="${ srcset }" media="(max-width: 767px)">
					<source srcset="${ srcset }" media="(max-width: 1199px)">
					<source srcset="${ srcset }">
					<img src="${ srcset }" alt="">
				</picture>
			`;
		videoBox.find('iframe').after(thumbnailTpl);
	}
}

/* - - - - - - - - - - - - - -       init exhibitions grid       - - - - - - - - - - - - - - - */
function initExhibitionsGrid() {
	const $exhibitionsGrid = $('.js-exhibitions-tile').masonry({
		gutter: 0,
		itemSelector: '.exhibition-box',
		stamp: '.exhibitions-stamp',
		horizontalOrder: true
	});
	$exhibitionsGrid.imagesLoaded().progress( function() {
		$exhibitionsGrid.masonry('layout');
	});
}

/* - - - - - - - - - - - - - -       set text height       - - - - - - - - - - - - - - - */
function setTextHeight($element) {
	const originalHtml = $element.html();
	const originalText = $element.text();
	const maxLength = $element.data('letters');
	const $btnBox = $element.parent().find('.text-more');
	const $btn = $btnBox.find('.btn');

	if (originalText.length <= maxLength) {
		$btnBox.css('display', '');
		return;
	} else {
		$element.addClass('shortened');
		$btnBox.css('display', 'block');
	}

	let charCount = 0;
	let truncatedHtml = '';

	const getAttributes = (node) => {
		let attrs = '';
		for (const attr of node.attributes) {
			attrs += ` ${attr.name}="${attr.value}"`;
		}
		return attrs;
	};

	const traverseNodes = (nodeList) => {
		for (const node of nodeList) {
			if (charCount >= maxLength) break;

			if (node.nodeType === Node.TEXT_NODE) {
				const text = node.textContent;
				const remaining = maxLength - charCount;
				if (text.length <= remaining) {
					truncatedHtml += text;
					charCount += text.length;
				} else {
					truncatedHtml += text.substring(0, remaining);
					charCount += remaining;
				}
			} else if (node.nodeType === Node.ELEMENT_NODE) {
				const tagName = node.nodeName.toLowerCase();
				truncatedHtml += `<${tagName}${getAttributes(node)}>`;
				traverseNodes(node.childNodes);
				truncatedHtml += `</${tagName}>`;
			}
		}
	};

	const tempElement = document.createElement('div');
	tempElement.innerHTML = originalHtml;

	traverseNodes(tempElement.childNodes);

	$element.data('full-html', originalHtml); // зберігаємо повний текст
	$element.html(truncatedHtml);
	$element.find('p').last().append('...');

	$btn.on('click', function (e) {
		e.preventDefault();
		if ($element.hasClass('shortened')) {
			$element.html($element.data('full-html'));
			$element.removeClass('shortened');
			$btn.addClass('active');
			$btn.find('span:not(.icon)').text($btn.data('text-hide'));
		} else {
			$element.html(truncatedHtml);
			$element.find('p').last().append('...');
			$element.addClass('shortened');
			$btn.removeClass('active');
			$btn.find('span:not(.icon)').text($btn.data('text-show'));

			if ($element.closest('.research-accordion__box').length) {
				const top = $(window).scrollTop();
				const posTop = $element.closest('.research-accordion__box').offset().top;
				const headerHeight = $('.header-pac, .header-fgap').length ? $('.header-pac, .header-fgap').innerHeight() : 0;
				let scrollTo = top > posTop ? posTop - headerHeight : posTop;
				$('html, body').animate({scrollTop: scrollTo}, 250);
			}
		}
	});
}

/* - - - - - - - - - - - - - -       set research publication       - - - - - - - - - - - - - - - */
function researchPublicationGrid($grid) {
	const gridItems = $grid.find('.research-publications__box');
	const maxCount = window.matchMedia('(max-width: 1199px)').matches ? 2 : 3;
	const $btnBox = $grid.parent().find('.research-publications__more');
	const $btn = $btnBox.find('.btn');

	gridItems.each((i, gridItem) => {
		$(gridItem).removeClass('show');
	});
	$btn.removeClass('active');
	$btn.find('span:not(.icon)').text($btn.data('text-show'));

	if (gridItems.length <= maxCount) {
		gridItems.each((i, gridItem) => {
			$(gridItem).addClass('show');
		});
		$btnBox.css('display', '');
		return;
	} else {
		gridItems.each((i, gridItem) => {
			if (i < maxCount) {
				$(gridItem).addClass('show');
			}
		});
		$grid.addClass('shortened');
		$btnBox.css('display', 'block');
	}

	$btn.on('click', function (e) {
		e.preventDefault();
		if ($grid.hasClass('shortened')) {
			$grid.removeClass('shortened');
			$btn.addClass('active');
			$btn.find('span:not(.icon)').text($btn.data('text-hide'));
			gridItems.each((i, gridItem) => {
				$(gridItem).addClass('show');
			});
		} else {
			$grid.addClass('shortened');
			$btn.removeClass('active');
			$btn.find('span:not(.icon)').text($btn.data('text-show'));
			gridItems.each((i, gridItem) => {
				if (i < maxCount) {
					$(gridItem).addClass('show');
				} else {
					$(gridItem).removeClass('show');
				}
			});

			if ($grid.closest('.research-accordion__box').length) {
				const top = $(window).scrollTop();
				const posTop = $grid.closest('.research-accordion__box').offset().top;
				const headerHeight = $('.header-pac, .header-fgap').length ? $('.header-pac, .header-fgap').innerHeight() : 0;
				let scrollTo = top > posTop ? posTop - headerHeight : posTop;
				$('html, body').animate({scrollTop: scrollTo}, 250);
			}
		}
	});
}

/* - - - - - - - - - - - - - -       scroll to Research Works Documents       - - - - - - - - - - - - - - - */
function scrollToResearchWorksDocuments() {
	if ($('.research-works__grid, .research-documents__grid').length) {
		const $researchGrid = $('.research-works__grid, .research-documents__grid');
		const $researchAccordion = $researchGrid.closest('.research-accordion__box');
		let headerHeight = 0;
		if ($researchAccordion.offset().top < $(window).scrollTop()) {
			headerHeight = $('.header-pac, .header-prize, .header-fgap').innerHeight();
		}
		const scrollTo = $researchAccordion.offset().top - headerHeight;
		$('html, body').animate({scrollTop: scrollTo}, 250);
	}
}

/* - - - - - - - - - - - - - -       show hide read more button       - - - - - - - - - - - - - - - */
function showHideReadMoreButton() {
	const readMoreBlocks = document.querySelectorAll('[data-read-more]');
	readMoreBlocks.forEach(item => {
		const readMoreContent = item.querySelector('.js-read-more-content');
		const readMoreBtn = item.querySelector('.js-read-more-btn');
		const readMoreBtnParent = readMoreBtn ? readMoreBtn.parentElement : null;
		const scrollInner = readMoreContent ? readMoreContent.querySelector('.scroll') : null;
		const reedMoreTitle = readMoreContent ? readMoreContent.querySelector('.title') : null;
		const reedMoreText = readMoreContent ? readMoreContent.querySelector('.text') : null;
		const isCollapsed = readMoreContent.classList.contains('collapsed');
		const titleHeight = reedMoreTitle ? reedMoreTitle.offsetHeight + (window.getComputedStyle(reedMoreTitle).marginTop ? parseInt(window.getComputedStyle(reedMoreTitle).marginTop) : 0) + (window.getComputedStyle(reedMoreTitle).marginBottom ? parseInt(window.getComputedStyle(reedMoreTitle).marginBottom) : 0) : 0;

		if (readMoreBtn && readMoreContent && scrollInner && reedMoreText) {
			if (reedMoreText.scrollHeight + titleHeight > scrollInner.clientHeight) {
				readMoreBtnParent.style.display = 'block';
			} else {
				if (!isCollapsed) {
					readMoreBtnParent.style.display = 'none';
				}
			}
		}
	});
}

$(document).ready(function () {
	toggleAdditionalField();

	// $('.js-password').on('input', function() {
	// 	checkPassword($(this).val());
	// });

	if ($('.cookie').length) {
		showCookieModal();
	}

	/* - - - - - - - - - - - - - -       toggle cookie       - - - - - - - - - - - - - - - */
	$(document).on('click', '.js-cookie-close', function( e ) {
		e.preventDefault();
		$('.cookie').removeClass( 'show' );
		$('.overflow').removeClass('show');
	});

	$(document).on('click', '.js-cookie-set', function() {
		$('.cookie').removeClass('show');
		$('.overflow').removeClass('show');
		const date = new Date( Date.now() + 86400e3 );
		document.cookie = 'cookieAccept=true; path=/; expires=' + date;
	});

	/* - - - - - - - - - - - - - -       init inputmask       - - - - - - - - - - - - - - - */
	// $( '[type="tel"]' ).inputmask( '+38 (999) 999 99 99' );

	/* - - - - - - - - - - - - - -       init slick       - - - - - - - - - - - - - - - */
	// $( '.js-slider' ).slick({
	// 	infinite: false,
	// 	arrows: true,
	// 	dots: false,
	// 	slidesToScroll: 1,
	// 	slidesToShow: 2
	// });

	/* - - - - - - - - - - - - - -       input validate       - - - - - - - - - - - - - - - */
	function setInput() {
		$('input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"]), textarea, select').each(function () {
			const $this = $(this);
			const $parent = $this.closest('.form-group');
			const isPlaceholder = $this.attr("placeholder") ? true : false;
			const isDataPlaceholder = $this.attr("data-placeholder") ? true : false;
			const isAutofill = $this[0].matches(':autofill') === true ? true : false;
			if ($this.val() !== '' || isPlaceholder || isDataPlaceholder || isAutofill) {
				$parent.addClass('filled');
			}
		});
	}
	// setInput(setInput, 10);
	setTimeout(setInput, 600);
	$(document).on('focus', 'input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"]), textarea', function () {
		const $parent = $(this).closest('.form-group');
		$parent.addClass('filled');
	});
	$(document).on('blur', 'input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"]), textarea', function () {
		$('input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"]), textarea').each(function () {
			const $this = $(this);
			const $parent = $this.closest('.form-group');
			const isPlaceholder = $this.attr('placeholder') ? true : false;
			if ($this.val() === '' && !$this.is(':focus') && !isPlaceholder) {
				$parent.removeClass('filled');
			}
			if ($parent.length) {
				const str = $this.val();
				const regUrl = /^https?:\/\//;
				if (str.match(regUrl)) {
					$this.val(str.replace(regUrl, ''));
				}
			}
		});
	});
	$(document).on('input blur', 'input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"])[data-required], textarea[data-required], input[data-url]', function () {
		validateInputField($(this));
	});
	$(document).on('input', 'input[data-letters-only]', function () {
		const value = $(this).val();
		$(this).val(value.replace(/[^A-Za-zА-Яа-яЁёІіЇїЄєҐґ ]/g, ''));
	});
	$(document).on('input', 'input[data-digits-only]', function () {
		const value = $(this).val();
		$(this).val(value.replace(/\D/g, ''));
	});
	$(document).on('input', 'textarea[data-latin-only]', function () {
		const value = $(this).val();
		$(this).val(value.replace(/[^\n\r\t -~\u00C0-\u024F\u1E00-\u1EFF]/g, ''));
	});
	$(document).on('input', '[type="checkbox"], [type="radio"]', function () {
		toggleAdditionalField();

		const $this = $(this);
		if ($this.attr('data-required') !== undefined) {
			const $form = $this.closest('form');
			if ($this.closest('.form-checkbox')) {
				// $this.closest('.form-checkbox').removeClass( 'has-success', 'has-error' );
				const checkboxList = $form.find(`[name="${$this.attr('name')}"][data-required]`);
				let isCheck = false;
				checkboxList.each((i, item) => {
					if ($(item).prop('checked')) {
						isCheck = true;
					}
				});
				let parentCheckboxValidate = $this.closest('.checkbox-column') && checkboxList.length === 1 ? $this.closest('.checkbox') : $this.closest('.form-checkbox');
				if (isCheck) {
					parentCheckboxValidate.removeClass('has-error');
					parentCheckboxValidate.addClass('has-success');
				} else {
					parentCheckboxValidate.removeClass('has-success');
					parentCheckboxValidate.addClass('has-error');
				}
			}
		}
	});
	// $('textarea').on('input', function () {
	// 	const $parent = $(this).closest('.form-group');
	// 	if ($(this).val() !== '') {
	// 		$parent.addClass('filled');
	// 	} else {
	// 		$parent.removeClass('filled');
	// 	}
	// });

	$(document).on('click', '.js-form-flex-delete', function () {
		$(this).closest('.form-flex').remove();
	});

	/* - - - - - - - - - - - - - -       scroll to hash       - - - - - - - - - - - - - - - */
	$(window).on('load', function () {
		const hash = decodeURIComponent(window.location.hash || '');

		if (hash.length > 1) {
			setTimeout(function () {
				scrollToHashTarget(hash);
			}, 100);
		}
	});

	$('a[href^="#"]').on('click', function (e) {
		if ($(this).attr('data-fancybox') === undefined) {
			e.preventDefault();
			const hash = $(this).attr('href');
			scrollToHashTarget(hash);
		}
	});

	/* - - - - - - - - - - - - - -       counter textarea       - - - - - - - - - - - - - - - */
	function counterTextarea($textarea, value, maxCount) {
		const $parent = $textarea.closest('.form-group');
		const $counter = $parent.find('.textarea-counter');
		const count = $textarea.val().length;
		$counter.text(`${count}/${maxCount}`);
		if (count > maxCount) {
			$parent.addClass('has-error');
		} else {
			$parent.removeClass('has-error');
		}
	}
	function initTextarea() {
		$('.js-textarea').each(function() {
			const $textarea = $(this);
			const $parent = $textarea.closest('.form-group');
			const defaultCount = 500;
			const maxCount = $textarea.data('count') && $textarea.data('count') !== '' ? parseInt($textarea.data('count')) : defaultCount;
			let value = $textarea.val();
			const counterTpl = `
				<span class="textarea-counter"></span>
			`;
			$parent.prepend(counterTpl);
			counterTextarea($textarea, value, maxCount);

			$textarea.on('input', function() {
				// const newValue = $textarea.val();
				// if (value.length < newValue.length && value.length >= maxCount) {
				// 	$textarea.val(value);
				// } else {
				// 	value = newValue;
				// }
				// if (newValue.length > maxCount) {
				// 	$textarea.val(newValue.slice(0, maxCount));
				// }
				counterTextarea($textarea, value, maxCount);
			});
		});
	}
	initTextarea();

	/* - - - - - - - - - - - - - -       toggle field password       - - - - - - - - - - - - - - - */
	$(document).on('click', '.js-toggle-view', function() {
		const $this = $(this);
		const $parent = $this.closest('.form-group');
		if (!$this.hasClass('active')) {
			$this.addClass('active');
			$parent.find('input').attr('type', 'text');
		} else {
			$this.removeClass('active');
			$parent.find('input').attr('type', 'password');
		}
	});

	/* - - - - - - - - - - - - - -       clear field       - - - - - - - - - - - - - - - */
	$('.js-clear-field').on('click', function() {
		const $this = $(this);
		const $parent = $this.closest('.form-group');
		const $field = $parent.find('input');
		$field.val('');
		if (!$field.attr('placeholder')) {
			$parent.removeClass('filled');
		}
	});

	/* - - - - - - - - - - - - - -       init select2       - - - - - - - - - - - - - - - */
	function initSelect() {
		$('.js-select').each(function () {
			const $select = $(this);
			const isMultiple = $select.prop('multiple');
			const isNoSearch = $select.hasClass('js-select-no-search');
			$select.select2({
				language: lang,
				width: "100%",
				dropdownPosition: "below",
				closeOnSelect: !isMultiple,
				placeholder: $select.data('placeholder') || '',
				minimumResultsForSearch: isNoSearch ? -1 : 0,
			})
				.on("select2:open", function (e) {
					const $parent = e.target.closest('.form-group');
					const isModal = e.target.closest('.modal');
					$($parent).addClass('filled');

					if (isModal) {
						$('.select2-container .select2-dropdown').addClass('select2-dropdown--modal');
					}

					const selectId = $(e.target).attr('id');
					const $container = selectId
						? $(`#select2-${selectId}-container`).closest('.select2-container')
						: $('.select2-container--open');

					if (isMultiple) {
						$container.addClass('is-multiselect');
					}

					const $dropdown = $('.select2-dropdown.select2-dropdown--below');
					if (isNoSearch) {
						$dropdown.addClass('no-search');
					}
				})
				.on("select2:close", function (e) {
					const $parent = $(e.target).closest('.form-group');
					const value = e.target.value;
					const isPlaceholder = $(e.target).attr('data-placeholder') ? true : false;

					if (value === "" && !isPlaceholder) {
						$parent.removeClass('filled');
					}

					$('.select2-container').removeClass('is-multiselect');
				})
				.on("select2:select", function (e) {
					const data = e.params.data;
					const $parent = $(e.target).closest('.form-group');
					if (data) {
						$parent.removeClass('has-error');
					} else {
						$parent.addClass('has-error');
					}
				});

			if (isMultiple) {
				const placeholder = $select.data('placeholder') || '';
				const $container = $select.next('.select2-container');
				const $rendered = $container.find('.select2-selection__rendered');
				if ($rendered.length) {
					$rendered.attr('aria-label', placeholder);
				}
			}
		});
	}
	setTimeout(initSelect, 10);

	function initRoundSelect() {
		$('.js-round-select').select2({
			language: lang,
			width: "100%",
			dropdownPosition: "below",
			minimumResultsForSearch: -1,
			selectionCssClass: 'round',
			dropdownCssClass: 'round'
		})
			.on("select2:open", function (e) {
				const $parent = e.target.closest('.form-group');
				$($parent).addClass('filled');
			})
			.on("select2:close", function (e) {
				const $parent = $(e.target).closest('.form-group');
				const value = e.target.value;
				const isPlaceholder = $(e.target).attr('data-placeholder') ? true : false;
				if (value === "" && !isPlaceholder) {
					$parent.removeClass('filled');
				}
			})
			.on("select2:select", function (e) {
				const data = e.params.data;
				const $parent = $(e.target).closest('.form-group');
				if (data) {
					$parent.removeClass('has-error');
				} else {
					$parent.addClass('has-error');
				}
				// console.log(data);
			});
	}
	// initRoundSelect();
	setTimeout(initRoundSelect, 10);

	function initSelectLang() {
		$('.js-select-lang').select2({
			language: lang,
			width: "100%",
			dropdownPosition: "below",
			minimumResultsForSearch: -1,
			selectionCssClass: 'lang',
			dropdownCssClass: 'lang'
		});
	}
	// initSelect();
	setTimeout(initSelectLang, 10);

	/* - - - - - - - - - - - - - -       input AirDatepicker       - - - - - - - - - - - - - - - */
	const localeEn = {
		days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
		daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
		daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
		months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
		monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		today: 'Today',
		clear: 'Clear',
		dateFormat: 'MM/dd/yyyy',
		timeFormat: 'hh:mm aa',
		firstDay: 0
	};
	const localeUk = {
		days: ['Неділя', 'Понеділок', 'Вівторок', 'Середа', 'Четвер', 'П’ятниця', 'Субота'],
		daysShort: ['Нед', 'Пнд', 'Вів', 'Срд', 'Чтв', 'Птн', 'Сбт'],
		daysMin: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
		months: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
		monthsShort: ['Січ', 'Лют', 'Бер', 'Кві', 'Тра', 'Чер', 'Лип', 'Сер', 'Вер', 'Жов', 'Лис', 'Гру'],
		today: 'Сьогодні',
		clear: 'Очистити',
		dateFormat: 'dd.MM.yyyy',
		timeFormat: 'HH:mm',
		firstDay: 1
	};
	const lang = $('html').attr('lang').slice(0, 2).toLowerCase();
	let dateLocale;
	if (lang === 'en') {
		dateLocale = localeEn;
	}
	if (lang === 'uk') {
		dateLocale = localeUk;
	}

	let currentDate = new Date();
	function initDatepicker() {
		$('.js-date').each((i, datepicker) => {
			const $parent = $(datepicker).closest('.form-group');
			const minAge = $(datepicker).data('min-age');
			const maxAge = $(datepicker).data('max-age');
			let minDate = maxAge !== undefined && maxAge !== '' ? new Date() : '';
			if (minDate !== '') {
				minDate.setFullYear(currentDate.getFullYear() - maxAge);
			}
			let maxDate = minAge !== undefined && minAge !== '' ? new Date() : '';
			if (maxDate !== '') {
				maxDate.setFullYear(currentDate.getFullYear() - minAge);
			}

			new AirDatepicker(datepicker, {
				locale: dateLocale,
				minDate: minDate,
				maxDate: maxDate,
				autoClose: true,
				dateFormat: 'dd/MM/yyyy',
				prevHtml: '<span class="icon icon-i-arr-small-left"></span>',
				nextHtml: '<span class="icon icon-i-arr-small-right"></span>',
				navTitles: {
					days: '<span>MMMM</span><span>yyyy</span><span class="icon icon-i-arr-small-down"></span>',
				},
				onSelect({date, formattedDate, datepicker}) {
					const $parent = $(datepicker.$el).closest('.form-group');
					if ( date !== undefined ) {
						$parent.addClass('filled');
						$parent.removeClass('has-error');
					} else {
						$parent.removeClass('filled');
						$parent.addClass('has-error');
					}
					progressFilledSubmission();

					const inputDate = datepicker.$el;
					inputDate.dispatchEvent(new Event('change', { bubbles: true }));
				},
				onShow(isFinished) {
					$parent.addClass('focused');
				},
				onHide(isFinished) {
					$parent.removeClass('focused');
				}
			});
		});
	}
	if ($('.js-date').length) {
		initDatepicker();
	}

	function initDatepickerYear() {
		$('.js-date-year').each((i, datepicker) => {
			const $parent = $(datepicker).closest('.form-group');
			const minYear = $(datepicker).data('min-year');
			const maxYear = $(datepicker).data('max-year');
			let minDate = minYear !== undefined && minYear !== '' ? new Date(Number(minYear), 0, 1) : '';
			let maxDate = maxYear !== undefined && maxYear !== '' ? new Date(Number(maxYear), 11, 31) : '';

			let value = $(datepicker).val();
			let selectedDates = [];
			if (value) {
				selectedDates = [new Date(Number(value), 0, 1)];
			}

			new AirDatepicker(datepicker, {
				locale: dateLocale,
				view: 'years',
				minView: 'years',
				minDate: minDate,
				maxDate: maxDate,
				selectedDates: selectedDates,
				autoClose: true,
				dateFormat: 'yyyy',
				prevHtml: '<span class="icon icon-i-arr-small-left"></span>',
				nextHtml: '<span class="icon icon-i-arr-small-right"></span>',
				navTitles: {
					days: '<span>yyyy</span><span class="icon icon-i-arr-small-down"></span>',
				},
				onSelect({date, formattedDate, datepicker}) {
					const $parent = $(datepicker.$el).closest('.form-group');
					if ( date !== undefined ) {
						$parent.addClass('filled');
						$parent.removeClass('has-error');
					} else {
						$parent.removeClass('filled');
						$parent.addClass('has-error');
					}
					if ($('.news-all-page').length) {
						let currentPage;
						if (typeof $('.news-all-page').data('type') !== 'undefined') {
							currentPage = $('.news-all-page').data('type');
							location.href = `/${currentPage}/?f-year=${formattedDate}`;
						}
					}

					const inputDate = datepicker.$el;
					inputDate.dispatchEvent(new Event('change', { bubbles: true }));
				},
				onShow(isFinished) {
					$parent.addClass('focused');
				},
				onHide(isFinished) {
					$parent.removeClass('focused');
				}
			});
		});
	}
	if ($('.js-date-year').length) {
		setTimeout(initDatepickerYear, 10);
	}

	let currentYearDate = new Date();
	function initYearRangeDatepicker($yearRange) {
		// const queryString = window.location.search;
		// const urlParams = new URLSearchParams(queryString);
		// const yearFrom = urlParams.get('year-from');
		// const yearTo = urlParams.get('year-to');

		const fieldDateStart = $yearRange.find('.js-year-date-start');
		const fieldDateEnd = $yearRange.find('.js-year-date-end');

		// if (yearFrom !== null && yearFrom !== '') {
		// 	fieldDateStart.val(yearFrom);
		// }
		// if (yearTo !== null && yearTo !== '') {
		// 	fieldDateEnd.val(yearTo);
		// }

		let minYear = parseInt(fieldDateStart.val(), 10);
		let maxYear = parseInt(fieldDateEnd.val(), 10);
		let minDate = !isNaN(minYear) ? new Date(minYear, 0, 1) : null;
		let maxDate = !isNaN(maxYear) ? new Date(maxYear, 11, 31) : null;
		const $parentDateStart = fieldDateStart.closest('.form-group');
		const $parentDateEnd = fieldDateEnd.closest('.form-group');
		const isFieldDateStartRight = fieldDateStart.is('[data-positions-right]') && window.matchMedia('(max-width: 767px)').matches;
		const isFieldDateEndRight = fieldDateEnd.is('[data-positions-right]') && window.matchMedia('(max-width: 767px)').matches;
		let startDatePicker;
		let endDatePicker;
		let isOpenDateStart = false;
		let isOpenDateEnd = false;
		const submitRangeForm = function() {
			if (this.form) {
				this.form.submit();
			}
		};
		startDatePicker = new AirDatepicker(fieldDateStart[0], {
			locale: dateLocale,
			view: 'years',
			minView: 'years',
			maxView: 'years',
			autoClose: true,
			dateFormat: 'yyyy',
			prevHtml: '<span class="icon icon-i-arr-small-left"></span>',
			nextHtml: '<span class="icon icon-i-arr-small-right"></span>',
			navTitles: {
				days: '<span>yyyy</span><span class="icon icon-i-arr-small-down"></span>',
			},
			position: isFieldDateStartRight ? 'bottom right' : 'bottom left',
			onSelect({date, formattedDate, datepicker}) {
				if (endDatePicker && date) {
					endDatePicker.update({
						minDate: new Date(date.getFullYear(), 0, 1)
					});
				}
				const inputDate = datepicker.$el;
				inputDate.dispatchEvent(new Event('change', { bubbles: true }));
			},
			onShow(isFinished) {
				$parentDateStart.addClass('focused');
			},
			onHide(isFinished) {
				$parentDateStart.removeClass('focused');
				isOpenDateStart = false;
			}
		});
		endDatePicker = new AirDatepicker(fieldDateEnd[0], {
			locale: dateLocale,
			view: 'years',
			minView: 'years',
			maxView: 'years',
			autoClose: true,
			dateFormat: 'yyyy',
			prevHtml: '<span class="icon icon-i-arr-small-left"></span>',
			nextHtml: '<span class="icon icon-i-arr-small-right"></span>',
			navTitles: {
				days: '<span>MMMM</span><span>yyyy</span><span class="icon icon-i-arr-small-down"></span>',
			},
			position: isFieldDateEndRight ? 'bottom right' : 'bottom left',
			onSelect({date, formattedDate, datepicker}) {
				if (startDatePicker && date) {
					startDatePicker.update({
						maxDate: new Date(date.getFullYear(), 11, 31)
					});
				}
				const inputDate = datepicker.$el;
				inputDate.dispatchEvent(new Event('change', { bubbles: true }));
			},
			onShow(isFinished) {
				$parentDateEnd.addClass('focused');
			},
			onHide(isFinished) {
				$parentDateEnd.removeClass('focused');
				isOpenDateEnd = false;
			}
		});
		fieldDateStart.off('change.yearRangeSubmit');
		fieldDateEnd.off('change.yearRangeSubmit');
		if (minDate) {
			startDatePicker.selectDate(minDate);
			endDatePicker.update({
				minDate: minDate
			});
			$parentDateStart.addClass('filled');
		}
		if (maxDate) {
			endDatePicker.selectDate(maxDate);
			startDatePicker.update({
				maxDate: maxDate
			});
			$parentDateEnd.addClass('filled');
		}
		setTimeout(function(){
			fieldDateStart.on('change.yearRangeSubmit', submitRangeForm);
			fieldDateEnd.on('change.yearRangeSubmit', submitRangeForm);
		}, 10);
		fieldDateStart.on('click', function(e) {
			e.stopPropagation();
			if (isOpenDateStart) {
				startDatePicker.hide();
			} else {
				startDatePicker.show();
			}
			isOpenDateStart = !isOpenDateStart;
		});
		fieldDateEnd.on('click', function(e) {
			e.stopPropagation();
			if (isOpenDateEnd) {
				endDatePicker.hide();
			} else {
				endDatePicker.show();
			}
			isOpenDateEnd = !isOpenDateEnd;
		});
	}
	function initYearRangeDatepickerAll() {
		$('.research-filter__year').each(function() {
			const $yearRange = $(this);
			if ($yearRange.find('.js-year-date-start').length && $yearRange.find('.js-year-date-end').length) {
				initYearRangeDatepicker($yearRange);
			}
		});
	}
	initYearRangeDatepickerAll();

	let currentPlanDate = new Date();
	// let minDate = new Date();
	// minDate.setFullYear(currentDate.getFullYear() - 35);
	// let maxDate = new Date();
	// maxDate.setFullYear(currentDate.getFullYear() - 18);
	function initPlanDatepicker() {
		let dateFormat = '';
		if (window.matchMedia('(max-width: 767px)').matches) {
			dateFormat = 'dd MMM yy';
		} else {
			dateFormat = 'dd MMMM yy';
		}
		$('.js-plan-date').each((i, datepicker) => {
			const $datepicker = $(datepicker);
			const $parent = $datepicker.closest('.plan-tabs__box-date');
			const allowAllDates = $datepicker.is('[data-all]');
			const openRight = $datepicker.is('[data-positions-right]') && window.innerWidth >= 1199;

			let isOpen = false;

			const planDatepicker = new AirDatepicker(datepicker, {
				locale: dateLocale,
				// minDate: currentPlanDate,
				minDate: allowAllDates ? '' : currentPlanDate,
				// maxDate: maxDate,
				autoClose: true,
				// dateFormat: dateFormat,
				position: openRight ? 'bottom right' : 'bottom left',

				dateFormat(date) {
					const day = date.getDate().toString().padStart(2, '0');
					const month = window.matchMedia('(max-width: 767px)').matches ? date.toLocaleString(lang, { month: 'short' }).toUpperCase() : date.toLocaleString(lang, { month: 'long' }).toUpperCase();
					const year = `‘${date.getFullYear().toString().slice(-2)}`;
					return `${day} ${month} ${year}`;
				},
				prevHtml: '<span class="icon icon-i-arr-small-left"></span>',
				nextHtml: '<span class="icon icon-i-arr-small-right"></span>',
				navTitles: {
					days: '<span>MMMM</span><span>yyyy</span><span class="icon icon-i-arr-small-down"></span>',
				},
				onSelect({date, formattedDate, datepicker}) {
					// if ( date !== undefined ) {
					// 	$( datepicker.$el ).closest( '.form-group' ).addClass( 'filled' );
					// } else {
					// 	$( datepicker.$el ).closest( '.form-group' ).removeClass( 'filled' );
					// }

					if (date) {
						const yyyy = date.getFullYear();
						const mm = String(date.getMonth() + 1).padStart(2, '0');
						const dd = String(date.getDate()).padStart(2, '0');
						const isoDate = `${yyyy}-${mm}-${dd}`;

						datepicker.$el.setAttribute('data-selected-date', isoDate);
					}

					const inputDate = datepicker.$el;
					inputDate.dispatchEvent(new Event('change', { bubbles: true }));
				},
				onShow(isFinished) {
					$parent.addClass('focused');
				},
				onHide(isFinished) {
					$parent.removeClass('focused');
					isOpen = false;
				}
			});

			$datepicker.on('click', function(e) {
				e.stopPropagation();
				if (isOpen) {
					planDatepicker.hide();
				} else {
					planDatepicker.show();
				}
				isOpen = !isOpen;
			});
		});
	}
	if ($('.js-plan-date').length) {
		initPlanDatepicker();
	}

	function initPlanMonthDatepicker() {
		let dateFormat = '';
		if (window.matchMedia('(max-width: 767px)').matches) {
			dateFormat = 'dd MMM yy';
		} else {
			dateFormat = 'dd MMMM yy';
		}
		$('.js-plan-month').each((i, datepicker) => {
			const $datepicker = $(datepicker);
			const $parent = $datepicker.closest('.plan-tabs__box-date');
			const allowAllDates = $datepicker.is('[data-all]');
			const openRight = $datepicker.is('[data-positions-right]') && window.innerWidth >= 1199;

			let isOpen = false;

			const planDatepicker = new AirDatepicker(datepicker, {
				locale: dateLocale,
				minDate: allowAllDates ? '' : currentPlanDate,
				autoClose: true,
				view: 'months',
				minView: 'months',
				position: openRight ? 'bottom right' : 'bottom left',

				dateFormat(date) {
					const day = date.getDate().toString().padStart(2, '0');
					const month = window.matchMedia('(max-width: 767px)').matches ? date.toLocaleString(lang, { month: 'short' }).toUpperCase() : date.toLocaleString(lang, { month: 'long' }).toUpperCase();
					const year = `‘${date.getFullYear().toString().slice(-2)}`;
					return `${month} ${year}`;
				},
				prevHtml: '<span class="icon icon-i-arr-small-left"></span>',
				nextHtml: '<span class="icon icon-i-arr-small-right"></span>',
				navTitles: {
					days: '<span>MMMM</span><span>yyyy</span><span class="icon icon-i-arr-small-down"></span>',
				},
				onSelect({date, formattedDate, datepicker}) {
					if (date) {
						const yyyy = date.getFullYear();
						const mm = String(date.getMonth() + 1).padStart(2, '0');
						const dd = String(date.getDate()).padStart(2, '0');
						const isoDate = `${yyyy}-${mm}`;

						datepicker.$el.setAttribute('data-selected-date', isoDate);
					}

					const inputDate = datepicker.$el;
					inputDate.dispatchEvent(new Event('change', { bubbles: true }));
				},
				onShow(isFinished) {
					$parent.addClass('focused');
				},
				onHide(isFinished) {
					$parent.removeClass('focused');
				}
			});

			$datepicker.on('click', function(e) {
				e.stopPropagation();
				if (isOpen) {
					planDatepicker.hide();
				} else {
					planDatepicker.show();
				}
				isOpen = !isOpen;
			});
		});
	}
	if ($('.js-plan-month').length) {
		initPlanMonthDatepicker();
	}

	function initPlanRangeDatepicker($planRange) {
		const planDateStart = $planRange.find('.js-plan-date-start');
		const $parentDateStert = planDateStart.closest('.plan-tabs__box-date');
		const startDatePicker = new AirDatepicker(planDateStart[0], {
			locale: dateLocale,
			minDate: currentPlanDate,
			autoClose: true,
			// dateFormat: 'dd MMM yy',
			dateFormat(date) {
				const day = date.getDate().toString().padStart(2, '0');
				const month = date.toLocaleString(lang, { month: 'short' }).toUpperCase();
				const year = `‘${date.getFullYear().toString().slice(-2)}`;
				return `${day} ${month} ${year}`;
			},
			prevHtml: '<span class="icon icon-i-arr-small-left"></span>',
			nextHtml: '<span class="icon icon-i-arr-small-right"></span>',
			navTitles: {
				days: '<span>MMMM</span><span>yyyy</span><span class="icon icon-i-arr-small-down"></span>',
			},
			onSelect({date, formattedDate, datepicker}) {
				endDatePicker.update({
					minDate: formattedDate.replace(/[‘’ʼ'`]/g, '') // Кінець не може бути раніше початку
				});

				const inputDate = datepicker.$el;
				inputDate.dispatchEvent(new Event('change', { bubbles: true }));
			},
			onShow(isFinished) {
				$parentDateStert.addClass('focused');
			},
			onHide(isFinished) {
				$parentDateStert.removeClass('focused');
			}
		});
		const planDateEnd = $planRange.find('.js-plan-date-end');
		const $parentDateEnd = planDateStart.closest('.plan-tabs__box-date');
		const endDatePicker = new AirDatepicker(planDateEnd[0], {
			locale: dateLocale,
			minDate: currentPlanDate,
			autoClose: true,
			// dateFormat: 'dd MMM yy',
			dateFormat(date) {
				const day = date.getDate().toString().padStart(2, '0');
				const month = date.toLocaleString(lang, { month: 'short' }).toUpperCase();
				const year = `‘${date.getFullYear().toString().slice(-2)}`;
				return `${day} ${month} ${year}`;
			},
			prevHtml: '<span class="icon icon-i-arr-small-left"></span>',
			nextHtml: '<span class="icon icon-i-arr-small-right"></span>',
			navTitles: {
				days: '<span>MMMM</span><span>yyyy</span><span class="icon icon-i-arr-small-down"></span>',
			},
			onSelect({date, formattedDate, datepicker}) {
				startDatePicker.update({
					maxDate: formattedDate.replace(/[‘’ʼ'`]/g, '') // Кінець не може бути раніше початку
				});
				// if ( date !== undefined ) {
				// 	$( datepicker.$el ).closest( '.form-group' ).addClass( 'filled' );
				// } else {
				// 	$( datepicker.$el ).closest( '.form-group' ).removeClass( 'filled' );
				// }

				const inputDate = datepicker.$el;
				inputDate.dispatchEvent(new Event('change', { bubbles: true }));
			},
			onShow(isFinished) {
				$parentDateEnd.addClass('focused');
			},
			onHide(isFinished) {
				$parentDateEnd.removeClass('focused');
			}
		});
	}
	$('.plan-tabs__box-range').each(function() {
		const $planRange = $(this);
		if ($planRange.find('.js-plan-date-start').length && $planRange.find('.js-plan-date-end').length) {
			initPlanRangeDatepicker($planRange);
		}
	});

	/* - - - - - - - - - - - - - -       init phone       - - - - - - - - - - - - - - - */
	function initPhone() {
		const phoneList = document.querySelectorAll('[type="tel"]');
		phoneList.forEach(phone => {
			if (!$(phone).closest('.iti').length) {
				const intlTel = intlTelInput(phone, {
					separateDialCode: true,
					// countrySearch: false,
					useFullscreenPopup: false,
					strictMode: true,
					excludeCountries: ['by', 'ru'],
					initialCountry: 'ua'
				});

				const inputTelHidden = $(phone).closest('.form-group').find('[type="hidden"]');
				const inputTelCode = intlTel.getSelectedCountryData().dialCode !== undefined ? `+${intlTel.getSelectedCountryData().dialCode}` : '';
				inputTelHidden.val(inputTelCode);

				phone.addEventListener('input', () => {
					if (phone.value.startsWith('0')) {
						phone.value = phone.value.slice(1);
					}
				});

				phone.addEventListener('countrychange', (e) => {
					const $parent = $(e.target).closest('.form-group');
					const hiddenField = $parent.find('[type="hidden"]');
					const code = $parent.find('.iti__selected-dial-code').text();
					hiddenField.val(code);
				});
			}
		});
	}
	// initPhone();
	setTimeout(initPhone, 10);



	document.querySelectorAll('[data-fancybox] a').forEach(function(link) {
		link.addEventListener('click', function(e) {
			e.stopPropagation();
		});
	});

	/* - - - - - - - - - - - - - -       init fancybox       - - - - - - - - - - - - - - - */
	Fancybox.bind( '[data-fancybox]', {
		autoFocus: false,
		placeFocusBack: false,
		dragToClose: false,
		closeExisting: true,
		Thumbs: false,
		// Carousel: {
		// 	Navigation: false,
		// 	// transition: 'slide',
		// },
		tpl: {
			closeButton: '<button data-fancybox-close class="f-button is-close-btn" title="{{CLOSE}}">' +
					'<span class="icon icon-i-close"></span>' +
				'</button>'
		},
		on: {
			init: (fancybox) => {
				$( '.header-fgap-overflow' ).removeClass( 'show' );
				$( '.header-pac-overflow, .header-prize-overflow' ).removeClass( 'show' );
				$( 'body' ).removeClass( 'no-scroll' );
				$( '.header-fgap-modal' ).removeClass( 'show' );
				$( '.header-pac-modal, .header-prize-modal' ).removeClass( 'show' );

				const target = fancybox && fancybox.userSlides[0];
				if (target) {
					const fancyboxTab = target.tab;
					const fancyboxSrc = target.src;
					if (fancyboxTab !== undefined) {
						$(fancyboxSrc).find('.tabs-list li a').removeClass('active');
						$(fancyboxSrc).find(`.tabs-list li a[data-tab="${fancyboxTab}"]`).addClass('active');
						$(fancyboxSrc).find('.tabs-box').removeClass('show');
						$(fancyboxSrc).find(`.tabs-box[data-tab="${fancyboxTab}"]`).addClass('show');
					}
				}

				setTimeout(showHideReadMoreButton, 10);
			},
			close: ( fancybox ) => {

			}
		}
	});

	/* - - - - - - - - - - - - - -       rebuild header       - - - - - - - - - - - - - - - */
	function rebuildHeader() {
		// const $headerMenu = $('.header-fgap-menu').detach();
		// const $headerRight = $('.header-fgap-right').detach();
		// const $headerLabel = $('.header-fgap-label').detach();
		// const $headerTop = $('.header-fgap-top');
		// const $headerBottom = $('.header-fgap-bottom');
		// const $headerLeft = $('.header-fgap-left');
		// const $action = $('.action');
		// const $headerModal = $('.header-fgap-modal');

		// const $headerLeft = $('.header-fgap-left').length
    // ? $('.header-fgap-left')
    // : $('.header-pac-left');

		const $headerMenu = $('.header-fgap-menu').length ? $('.header-fgap-menu').detach() : $('.header-pac-menu').detach();
		const $headerRight = $('.header-fgap-right').length ? $('.header-fgap-right').detach() : $('.header-pac-right').detach();
		const $headerLabel = $('.header-fgap-label').length ? $('.header-fgap-label').detach() : $('.header-pac-label').detach();
		const $headerTop = $('.header-fgap-top').length ? $('.header-fgap-top') : $('.header-pac-top');
		const $headerBottom = $('.header-fgap-bottom').length ? $('.header-fgap-bottom') : $('.header-pac-bottom');
		const $headerLeft = $('.header-fgap-left').length ? $('.header-fgap-left') : $('.header-pac-left');
		const $action = $('.action');
		const $headerModal = $('.header-fgap-modal').length ? $('.header-fgap-modal') : $('.header-pac-modal');
		if (window.matchMedia('(max-width: 1199px)').matches) {
			if ($action.length) {
				$action.append($headerLabel);
			}
		} else {
			$headerLeft.append($headerLabel);
		}
		if (window.matchMedia('(max-width: 767px)').matches) {
			$headerModal.append($headerRight);
			$headerModal.append($headerMenu);
		} else {
			$headerTop.append($headerRight);
			$headerBottom.append($headerMenu);
		}
	}
	rebuildHeader();
	$(window).on('resize', rebuildHeader);

	/* - - - - - - - - - - - - - -       rebuild header prize       - - - - - - - - - - - - - - - */
	function rebuildHeaderPrize() {
		const $headerPrizeMenu = $('.header-prize-menu').detach();
		const $headerPrizeView = $('.header-prize-view').detach();
		const $headerPrizeLeft = $('.header-prize-left').detach();
		const $headerPrizeRight = $('.header-prize-right').detach();
		const $headerPrizeTop = $('.header-prize-top');
		const $headerPrizeBottom = $('.header-prize-bottom');
		const $headerPrizeModal = $('.header-prize-modal');
		if (window.matchMedia('(max-width: 767px)').matches) {
			$headerPrizeModal.append($headerPrizeRight);
			$headerPrizeModal.append($headerPrizeLeft);
			$headerPrizeModal.append($headerPrizeMenu);
			$headerPrizeRight.prepend($headerPrizeView);
		} else {
			$headerPrizeTop.prepend($headerPrizeLeft);
			$headerPrizeTop.append($headerPrizeRight);
			$headerPrizeBottom.append($headerPrizeMenu);
			if (window.matchMedia('(max-width: 1199px)').matches) {
				$headerPrizeLeft.append($headerPrizeView);
			} else {
				$headerPrizeRight.prepend($headerPrizeView);
			}
		}
	}
	rebuildHeaderPrize();
	$(window).on('resize', rebuildHeaderPrize);

	/* - - - - - - - - - - - - - -       show header header       - - - - - - - - - - - - - - - */
	function showHeaderModal() {
		$('body').addClass('no-scroll');
		$('.header-fgap-overflow').addClass('show');
		$('.header-pac-overflow, .header-prize-overflow').addClass('show');
		$('.header-fgap-modal').addClass('show');
		$('.header-pac-modal, .header-prize-modal').addClass('show');

		$('.header-pac-search__toggle, .header-prize-search__toggle, .header-fgap-search__toggle').removeClass('active');
		$('.header-pac-search__modal, .header-prize-search__modal, .header-fgap-search__modal').removeClass('show');
	}

	/* - - - - - - - - - - - - - -       hide header header       - - - - - - - - - - - - - - - */
	function hideHeaderModal() {
		$('body').removeClass('no-scroll');
		$('.header-fgap-overflow').removeClass('show');
		$('.header-pac-overflow, .header-prize-overflow').removeClass('show');
		$('.header-fgap-modal').removeClass('show');
		$('.header-pac-modal, .header-prize-modal').removeClass('show');

		$('.header-pac-search__toggle, .header-prize-search__toggle, .header-fgap-search__toggle').removeClass('active');
		$('.header-pac-search__modal, .header-prize-search__modal, .header-fgap-search__modal').removeClass('show');
	}

	$('.js-header-fgap-open').on('click', showHeaderModal);
	$('.js-header-pac-open, .js-header-prize-open').on('click', showHeaderModal);
	$('.js-header-fgap-close').on('click', hideHeaderModal);
	$('.js-header-pac-close, .js-header-prize-close').on('click', hideHeaderModal);
	$('.header-fgap-overflow').on('click', hideHeaderModal);
	$('.header-pac-overflow, .header-prize-overflow').on('click', hideHeaderModal);

	$(window).on('resize', function () {
		if (window.matchMedia('(min-width: 768px)').matches) {
			hideHeaderModal();
		}
	});

	/* - - - - - - - - - - - - - -       toggle header submenu       - - - - - - - - - - - - - - - */
	$('.header-pac-menu a, .header-fgap-menu a').on('click', function(e) {
		const $li = $(this).closest('li');
		const $liList = $li.find('ul');
		if ($liList.length) {
			if (!$li.hasClass('show') && window.matchMedia('(hover: none)').matches) {
				e.preventDefault();
				$li.addClass('show');
				$liList.slideDown(250);
			}
		}
	});
	// $(window).on('orientationchange', function () {
	// 	console.log(11)
	// })
	$(window).on('resize', function () {
		if (window.matchMedia('(hover: hover)').matches) {
			$('.header-pac-menu li ul, .header-fgap-menu li ul').css('display', '');
		}
	});
	$(document).on('click', (e) => {
		if (!$(e.target).closest('li.show').closest('.header-pac-menu, .header-fgap-menu').length) {
			if (window.matchMedia('(hover: none)').matches) {
				$('.header-pac-menu li, .header-fgap-menu li').removeClass('show');
				$('.header-pac-menu li ul, .header-fgap-menu li ul').slideUp(250);
			}
		}
	});
	$(window).on('resize', function () {
		setTimeout(function () {
			if (window.matchMedia('(hover: hover)').matches) {
				$('.header-pac-menu li, .header-fgap-menu li').removeClass('show');
				$('.header-pac-menu li ul, .header-fgap-menu li ul').css('display', '');
			}
		}, 10);
	});

	/* - - - - - - - - - - - - - -       toggle header search modal       - - - - - - - - - - - - - - - */
	$('.js-header-pac-search, .js-header-prize-search, .js-header-fgap-search').on('click', function(e) {
		const $this = $(this);
		if (!$this.hasClass('active')) {
			$this.addClass('active');
			$('body').addClass('no-scroll');
			$('.header-pac-modal, .header-prize-modal, .header-fgap-modal').removeClass('show');
			$('.header-pac-overflow, .header-prize-overflow, .header-fgap-overflow').addClass('show');
			$('.header-pac-search__modal, .header-prize-search__modal, .header-fgap-search__modal').addClass('show');
		} else {
			$this.removeClass('active');
			$('body').removeClass('no-scroll');
			$('.header-pac-overflow, .header-prize-overflow, .header-fgap-overflow').removeClass('show');
			$('.header-pac-search__modal, .header-prize-search__modal, .header-fgap-search__modal').removeClass('show');
		}
	});

	/* - - - - - - - - - - - - - -       init action modal       - - - - - - - - - - - - - - - */
	$('.js-action-modal').on('click', function(e) {
		e.preventDefault();
		const $this = $(this);
		const link = $this.data('modal');
		if ($(link).length) {

			if (!$this.hasClass('active')) {
				$('.action-box__button').removeClass('active');
				$this.addClass('active');
				$('.action-modal').removeClass('show');
				$(link).addClass('show');
				$('.overflow').addClass('show');
				$('body').addClass('no-scroll');
			} else {
				$this.removeClass('active');
				$(link).removeClass('show');
				$('.overflow').removeClass('show');
				$('body').removeClass('no-scroll');
			}
		}
	});

	$('.overflow').on('click', function() {
		$(this).removeClass('show');
		$('body').removeClass('no-scroll');
		$('.action-box__button').removeClass('active');
		$('.action-modal').removeClass('show');
	});

	/* - - - - - - - - - - - - - -       init events grid       - - - - - - - - - - - - - - - */
	// function initTileGrid() {
	// 	const $tileGrid = $('.js-tile-grid').masonry({
	// 		gutter: 0,
	// 		itemSelector: '.tile-box',
	// 		// horizontalOrder: true
	// 	});
	// 	$tileGrid.imagesLoaded().progress( function() {
	// 		$tileGrid.masonry('layout');
	// 	});
	// }
	// initTileGrid();

	/* - - - - - - - - - - - - - -       progress filled submission       - - - - - - - - - - - - - - - */
	if ( $('.accordion-box').length ) {
		// progressFilledSubmission();
		setTimeout(progressFilledSubmission, 10);
		$(document).on('input', 'input, textarea, select', function () {
			setTimeout(progressFilledSubmission, 50);
		});
	}

	/* - - - - - - - - - - - - - -       remove Work/Member box       - - - - - - - - - - - - - - - */
	$(document).on('click', '.js-submission-close', function(e) {
		e.preventDefault();
		$(this).closest('.submission-box').remove();
		progressFilledSubmission();
	});

	/* - - - - - - - - - - - - - -       toggle form tabs       - - - - - - - - - - - - - - - */
	$('.js-form-tabs [data-tab]').on('click', function() {
		const $this = $(this);
		const $parent = $this.closest(".form-tabs").parent();
		if (!$this.hasClass('active')) {
			$parent.find(".form-tabs [data-tab]").removeClass('active');
			$this.addClass('active');
			$parent.find('.form-content [data-tab]').removeClass('show');
			$parent.find(`.form-content [data-tab="${$this.attr('data-tab')}"]`).addClass('show');
		}
	});

	/* - - - - - - - - - - - - - -       toggle tabs       - - - - - - - - - - - - - - - */
	$('.js-tabs [data-tab]').on('click', function() {
		const $this = $(this);
		const $tabsList = $this.closest('.tabs-list');
		const $tabs = $this.closest('.tabs');
		const $tabsScroll = $tabsList.find('.tabs-list__scroll');
		const offsetLeft = parseInt($tabsScroll.css('padding-left'));
		const posLeft = $this.closest('li').position().left - offsetLeft;
		if (!$this.hasClass('active')) {
			$tabsList.find('[data-tab]').removeClass('active');
			$this.addClass('active');
			$tabs.find('.tabs-content [data-tab]').removeClass('show');
			$tabs.find(`.tabs-content [data-tab="${$this.attr('data-tab')}"]`).addClass('show');
			$tabsScroll.animate({scrollLeft: `${posLeft}px`}, 250);
			$('.submission-sidebar__step-group').removeClass('show');
			$(`.submission-sidebar__step-group[data-tab="${$this.attr('data-tab')}"]`).addClass('show');
			progressFilledSubmission();
			initEventsGrid();
			initResearchArchiveGrid();
			showHideReadMoreButton();
		}
	});

	function sliderTabs() {
		$('.js-slider-tabs').each(function() {
			const $tabs = $(this);
			const $tabsScroll = $tabs.find('.tabs-list__scroll');
			const $buttonPrev = $tabs.find('.tabs-prev');
			const $buttonNext = $tabs.find('.tabs-next');
			const scrollPadding = parseInt($tabsScroll.css('padding-left'));
			const maxWidth = Math.ceil($tabs.innerWidth() - scrollPadding * 2);
			let scrollWidth = 0;
			let scrollPos = 0;
			$tabsScroll.find('li').each(function() {
				const $this = $(this);
				scrollWidth += $this.innerWidth();
			});
			scrollWidth = Math.ceil(scrollWidth);
			$buttonPrev.removeClass('show');
			$buttonNext.removeClass('show');
			if (maxWidth > 0 && maxWidth < scrollWidth) {
				$buttonNext.addClass('show');
			}
			$tabsScroll.on('scroll', function() {
				scrollPos = $tabsScroll.scrollLeft();
				if (scrollPos === 0) {
					$buttonPrev.removeClass('show');
				} else {
					$buttonPrev.addClass('show');
				}

				if (scrollPos + maxWidth >= scrollWidth - 1) {
					$buttonNext.removeClass('show');
				} else {
					$buttonNext.addClass('show');
				}
			});
			$buttonPrev.click(function() {
				let isScroll = true;
				let scrollIndex = 0;
				$tabsScroll.find('li').each(function() {
					const $this = $(this);
					if (isScroll) {
						if ($this.position().left - scrollPos + 1 > 0) {
							isScroll = false;
							scrollIndex = $this.index();
						}
					}
				});
				// scrollPos -= 50;
				scrollPos = $tabsScroll.find(`li:nth-child(${scrollIndex})`).position().left;
				$tabsScroll.animate({scrollLeft: scrollPos}, 250);
			});
			$buttonNext.click(function() {
				let isScroll = true;
				let scrollIndex = 0;
				$tabsScroll.find('li').each(function() {
					const $this = $(this);
					if (isScroll) {
						if ($this.position().left - scrollPos - 1 > 0) {
							isScroll = false;
							scrollIndex = $this.index();
						}
					}
				});
				// scrollPos += 50;
				scrollPos = $tabsScroll.find(`li:nth-child(${scrollIndex + 1})`).position().left;
				$tabsScroll.animate({scrollLeft: scrollPos}, 250);
			});
		});
	}
	if ($('.js-slider-tabs').length) {
		sliderTabs();
		setTimeout(sliderTabs, 1000);
		$(window).on('resize', sliderTabs);
	}

	/* - - - - - - - - - - - - - -       toggle accordion       - - - - - - - - - - - - - - - */
	if ($('.accordion-box').length) {
		$('.accordion-box').each(function() {
			const $this = $(this);
			if ($this.hasClass('show')) {
				$this.find('.accordion-box__body').slideDown(0);
			}
		});
	}

	$('.js-accordion').on('click', function() {
		const $this = $(this);
		const $parent = $this.closest('.accordion-box');
		if (!$parent.hasClass('show')) {
			$parent.addClass('show');
			$parent.find('.accordion-box__body').slideDown(950);
		} else {
			$parent.removeClass('show');
			$parent.find('.accordion-box__body').slideUp(750);
		}
	});


	$('.js-accordion-solo').on('click', function () {
		const $this = $(this);
		const $parent = $this.closest('.accordion-box');

		if (!$parent.hasClass('show')) {
			$('.js-accordion-solo')
				.closest('.accordion-box.show')
				.not($parent)
				.removeClass('show')
				.find('.accordion-box__body')
				.slideUp(750);

			$parent.addClass('show');
			$parent.find('.accordion-box__body').slideDown(950);
		} else {
			$parent.removeClass('show');
			$parent.find('.accordion-box__body').slideUp(750);
		}
	});

	/* - - - - - - - - - - - - - -       add image       - - - - - - - - - - - - - - - */
	// function addImage($uploadFile, id, file, fileSrc) {
	// 	const fileTpl = `
	// 		<div id="file-${id}" class="form-upload__file">
	// 			<div class="form-upload__file-img"><img src="${fileSrc}" alt="${file.name}"></div>
	// 			<div class="form-upload__file-title">${file.name}</div>
	// 			<div class="form-upload__file-remove js-remove-file" data-id="${id}"><span class="icon icon-i-close"></span></div>
	// 		</div>
	// 	`;
	// 	const $uploadList = $uploadFile.find('.form-upload__list');
	// 	$uploadList.append(fileTpl);
	// }

	/* - - - - - - - - - - - - - -       upload file       - - - - - - - - - - - - - - - */
	// let fileSrc;
	// function initUploadFile() {
	// 	$('.js-upload-file').each(function() {
	// 		const $upload = $(this);
	// 		const defaultSize = 3000000;
	// 		const defaultType = ['jpg', 'jpeg', 'png', 'gif', 'svg'];
	// 		const uploadSize = $upload.data('size') && $upload.data('size') !== '' ? parseInt($upload.data('size')) : defaultSize;
	// 		const uploadType = $upload.data('type') && $upload.data('type') !== '' ? $upload.data('type').split(',').map(type => type.trim()) : defaultType;
	// 		$upload.dmUploader({
	// 			url: '/img',
	// 			maxFiles: 3,
	// 			maxFileSize: uploadSize,
	// 			allowedTypes: 'image/*',
	// 			extFilter: uploadType,
	// 			onNewFile: function(id, file) {
	// 				console.log('Новий файл');
	// 				const $uploadFile = $(this).closest('.form-upload');
	// 				if (typeof FileReader !== 'undefined') {
	// 					const reader = new FileReader();
	//
	// 					reader.onload = function (e) {
	// 						fileSrc = e.target.result;
	// 						addImage($uploadFile, id, file, fileSrc);
	// 					};
	//
	// 					/* ToDo: do something with the img! */
	// 					reader.readAsDataURL(file);
	// 				}
	// 			},
	// 			onDragEnter: function() {
	// 				// Дії при заході файлів в область завантаження
	// 				console.log('Файл зайшов в область');
	// 				$(this).addClass('active');
	// 			},
	// 			onDragLeave: function() {
	// 				// Дії при виході файлів з області завантаження
	// 				console.log('Файл залишив область');
	// 				$(this).removeClass('active');
	// 			},
	// 			onInit: function() {
	// 				// Викликається при ініціалізації плагіна
	// 				console.log('dmUploader ініціалізовано');
	// 			},
	// 			onBeforeUpload: function(id) {
	// 				console.log('Файл ' + id + ' готується до завантаження');
	// 			},
	// 			onComplete: function() {
	// 				// Викликається коли завантаження завершено
	// 				console.log('Завершено завантаження');
	// 			},
	// 			onUploadProgress: function(id, percent) {
	// 				// Прогрес завантаження для конкретного файлу
	// 				console.log(`Завантаження файлу ${id}: ${percent}%`);
	// 				$(`#file-${id}`).find('.form-upload__file-img').html('<span class="icon icon-i-loading"></span>');
	// 			},
	// 			onUploadSuccess: function(id, data) {
	// 				// Викликається при успішному завантаженні файлу
	// 				console.log(`Файл ${id} успішно завантажено`);
	// 				// console.log($(this));
	// 				const file = data.files[0];
	// 				// const fileUrl = `/img/${fileName}`;
	// 				$(`#file-${id}`).find('.form-upload__file-img').html(`<img src="${fileSrc}" alt="${file.name}">`);
	// 			},
	// 			onUploadError: function(id, xhr, status, message) {
	// 				// Викликається, якщо сталася помилка під час завантаження
	// 				console.log(`Помилка завантаження файлу ${id}: ${message}`);
	// 				$(`#file-${id}`).addClass('error');
	// 				$(`#file-${id}`).find('.form-upload__file-img').html('<span class="icon icon-i-photo"></span>');
	// 			},
	// 			onFileTypeError: function(file) {
	// 				alert('Тип файлу не дозволений: ' + file.name);
	// 			},
	// 			onFileSizeError: function(file) {
	// 				alert('Файл занадто великий: ' + file.name);
	// 			},
	// 			onFallbackMode: function() {
	// 				alert('Ваш браузер не підтримує функціонал drag-and-drop');
	// 			}
	// 		});
	// 	});
	// }
	// if ( $('.js-upload-file').length ) {
	// 	initUploadFile();
	// }

	/* - - - - - - - - - - - - - -       remove file       - - - - - - - - - - - - - - - */
	// $(document).on('click', '.js-remove-file', function() {
	// 	let fileId = $(this).data('id');
	// 	$(`#file-${fileId}`).remove();
	// 	console.log('Файл з ID ' + fileId + ' видалено');
	// });

	/* - - - - - - - - - - - - - -       set number submission       - - - - - - - - - - - - - - - */
	function setNumberGroup($parent) {
		const $submission = $parent.parent();
		$submission.find('.submission-box').each((i, item) => {
			let closeTpl = '';
			if (i && !$(item).find('.submission-close').length) {
				closeTpl =
					`<a href="javascript:void(0);" class="submission-close js-submission-close">
					<span class="icon icon-i-close"></span>
				</a>`;
			}
			$(item).prepend(closeTpl);
			$(item).find('.submission-box__title b').text(i + 1);
			$(item).find('input').each((inFi, inputField) => {
				// console.log($(inputField))
				const newName = $(inputField).attr('name') && $(inputField).attr('name').replace(/\[\d+\]/, `[${i + 1}]`);
				$(inputField).attr('name', newName);
			});
		});
	}

	/* - - - - - - - - - - - - - -       set checkbox id       - - - - - - - - - - - - - - - */
	function setId($parent) {
		$parent.find('[type="checkbox"], [type="radio"]').each(function() {
			const $this = $(this);
			const $label = $this.siblings('label');
			const name = $this.attr('name');
			const regExp = /\[\d*\](\[\d*\])*/g;
			const result = name.match(regExp);
			let newName = '';
			if (result) {
				newName = name.replace(regExp, `-${generateRandomString(11)}`);
			} else {
				newName = `${name}-${generateRandomString(11)}`;
			}
			$this.attr('id', newName);
			$this.prop('checked', false);
			$label.attr('for', newName);
		});
	}

	function getClone($this) {
		const $parent = $this.closest('.form-add');
		const $info = $parent.find('.form-add__info');
		const minCount = $this.data('min-count') ? $this.data('min-count') : false;
		const maxCount = $this.data('max-count') ? $this.data('max-count') : false;
		const count = $parent.parent().find('> [data-duplicate]').length + 1;
		if (minCount) {
			if (minCount <= count) {
				$info.addClass('hidden');
			} else {
				$info.find('> *').removeClass('show');
				$info.find('> *').eq(count - 1).addClass('show');
				$info.removeClass('hidden');
			}
		} else {
			$info.find('> *').removeClass('show');
			$info.find('> *').eq(0).addClass('show');
		}
		if (maxCount && maxCount <= count) {
			$parent.addClass('hidden');
		} else {
			$parent.removeClass('hidden');
		}
	}

	function disableClone() {
		$('.js-clone-field').each(function() {
			const $this = $(this);
			getClone($this);
		});
	}
	if($('.js-clone-field').length) {
		disableClone();
	}

	/* - - - - - - - - - - - - - -       clone box       - - - - - - - - - - - - - - - */
	// $(document).on('click', '.js-clone-video-field', function(e) {
	// 	e.preventDefault();
	// 	const $this = $(this);
	// 	const $parent = $this.closest('.form-add');
	// 	const cloneVideoTpl = $parent.parent().find(`[data-clone="${$this.data('clone')}"]`).not($this).clone();
	// 	cloneVideoTpl.removeAttr('data-clone');
	// 	cloneVideoTpl.attr('data-duplicate', '');
	// 	cloneVideoTpl.find('.filled').removeClass('filled');
	// 	cloneVideoTpl.find('input').val('');
	// 	$parent.before(cloneVideoTpl);
	// 	setInput();
	// 	progressFilledSubmission();
	// 	getClone($this, $parent);
	// });

	/* - - - - - - - - - - - - - -       clone box       - - - - - - - - - - - - - - - */
	$(document).on('click', '.js-clone-field', function(e) {
		e.preventDefault();
		const $this = $(this);
		const $parent = $this.closest('.form-add');
		const cloneTpl = $parent.parent().find(`[data-clone="${$this.data('clone')}"]`).not($this).clone();
		cloneTpl.attr('data-duplicate', '');
		// if (~cloneTpl.attr('data-clone').indexOf('video-')) {
		// 	cloneTpl.attr('data-duplicate', '');
		// } else {
		// 	cloneTpl.find('[data-duplicate]').remove();
		// }
		cloneTpl.find('[data-duplicate]').remove();
		cloneTpl.removeAttr('data-clone');
		cloneTpl.find('.filled').removeClass('filled');
		const $cloneFields = cloneTpl.find('input:not([type="checkbox"]):not([type="radio"]), textarea, select');
		$cloneFields.val('').removeAttr('readonly');
		$cloneFields.filter('input').removeAttr('value');
		setId(cloneTpl);
		cloneTpl.find('.form-upload__list').html('');
		cloneTpl.find('.select2').remove();
		if (cloneTpl.find('.iti').length) {
			const $field = cloneTpl.find('.iti').closest('.form-field');
			const input = $field.find('[type="tel"]').clone();
			input.val('').removeAttr('value placeholder');
			cloneTpl.find('.iti').remove();
			$field.append(input);
		}
		$parent.before(cloneTpl);
		setInput();
		initTextarea();
		initSelect();
		initRoundSelect();
		toggleAdditionalField();
		if (cloneTpl.find('.js-upload-file').length) {
			cloneTpl.find('.js-upload-file').each(function() {
				initUploadFile($(this));
			});
		}
		initDatepicker();
		initPhone();
		setNumberGroup(cloneTpl);
		progressFilledSubmission();
		disableClone();
	});

	// /* - - - - - - - - - - - - - -       toggle plan tabs       - - - - - - - - - - - - - - - */
	// /* - - - - - - - - - - - - - -       toggle partners tabs       - - - - - - - - - - - - - - - */
	// /* - - - - - - - - - - - - - -       toggle prizerules tabs       - - - - - - - - - - - - - - - */
	// /* - - - - - - - - - - - - - -       toggle works tabs       - - - - - - - - - - - - - - - */
	// /* - - - - - - - - - - - - - -       toggle exhibition-tabs tabs       - - - - - - - - - - - - - - - */
	// /* - - - - - - - - - - - - - -       toggle artist-exhibition tabs       - - - - - - - - - - - - - - - */

	function toggleTabs(tabContainerClass, isScroll = false) {
		// $(`.${tabContainerClass} [data-tab]`).on('click', function() {
		$(`.${tabContainerClass} [data-tab][href]`).on('click', function() {
			const $this = $(this);
			const $parent = $this.closest(`.${tabContainerClass}`);
			const $tabList = $this.closest(`ul`);
			const offsetLeft = parseInt($tabList.css('padding-left'));
			const posLeft = $this.position().left - offsetLeft;
			if (!$this.hasClass('active')) {
				$parent.find(`.${tabContainerClass}__list [data-tab]`).removeClass('active');
				$this.addClass('active');
				$parent.find(`.${tabContainerClass}__content [data-tab]`).removeClass('show');
				$parent.find(`.${tabContainerClass}__content [data-tab="${$this.attr('data-tab')}"]`).addClass('show');
				$tabList.animate({scrollLeft: `${posLeft}px`}, 250);
				if (isScroll) {
					const top = $(window).scrollTop();
					const posTop = $parent.closest('.section').offset().top - 24;
					const headerHeight = $('.header-pac, .header-fgap').length ? $('.header-pac, .header-fgap').innerHeight() : 0;
					let scrollTo = top > posTop ? posTop - headerHeight : posTop;
					$('html, body').animate({scrollTop: scrollTo}, 250);
				}
			}
			// Masonry reactivate
			initWorksGrid();
		});
	}

	// Initialize tab toggling for each tab container
	toggleTabs('plan-tabs');
	toggleTabs('partners-tabs');
	toggleTabs('prizerules-tabs');
	toggleTabs('works-tabs');
	toggleTabs('exhibition-tabs-tabs', true);
	toggleTabs('artist-exhibition-tabs');
	toggleTabs('research-tabs');

	/* - - - - - - - - - - - - - -       rebuild banner       - - - - - - - - - - - - - - - */
	function rebuildBanner() {
		const $bannerNavigation = $('.banner-box__navigation').detach();
		if (window.matchMedia('(max-width: 767px)').matches) {
			$('.banner-slider').append($bannerNavigation);
		} else {
			$('.banner-box__body').prepend($bannerNavigation);
		}
	}
	rebuildBanner();
	$(window).on('resize', rebuildBanner);



	/* - - - - - - - - - - - - - -       init banner slider       - - - - - - - - - - - - - - - */
	let splideBannerSlider;
	function initBannerPagination() {
		const $bannerPagination = $('.banner-box__pagination');
		const activeIndex = splideBannerSlider.index;
		const countSlides = splideBannerSlider.length;
		const countVisible = 4;
		let paginationTpl = '';
		let paginationButtonsTpl = '';
		if (countSlides <= countVisible) {
			for (let i = 0; i < countSlides; i++) {
				paginationButtonsTpl += `<li><button class="banner-box__pagination-page" data-slide="${i}">${i + 1}</button></li>`;
			}
		} else {
			if (activeIndex <= 2) {
				for (let i = 0; i < countVisible - 1; i++) {
					paginationButtonsTpl += `<li><button class="banner-box__pagination-page" data-slide="${i}">${i + 1}</button></li>`;
				}
				paginationButtonsTpl += `<li><span class="banner-box__pagination-page">...</span></li>`;
				paginationButtonsTpl += `<li><button class="banner-box__pagination-page" data-slide="${countSlides - 1}">${countSlides}</button></li>`;
			} else if (activeIndex >= countSlides - 3) {
				paginationButtonsTpl += `<li><button class="banner-box__pagination-page" data-slide="0">1</button></li>`;
				paginationButtonsTpl += `<li><span class="banner-box__pagination-page">...</span></li>`;
				for (let i = countSlides - countVisible + 1; i < countSlides; i++) {
					paginationButtonsTpl += `<li><button class="banner-box__pagination-page" data-slide="${i}">${i + 1}</button></li>`;
				}
			} else {
				paginationButtonsTpl += `<li><button class="banner-box__pagination-page" data-slide="0">1</button></li>`;
				paginationButtonsTpl += `<li><span class="banner-box__pagination-page">...</span></li>`;
				paginationButtonsTpl += `<li><button class="banner-box__pagination-page" data-slide="${activeIndex}">${activeIndex + 1}</button></li>`;
				paginationButtonsTpl += `<li><span class="banner-box__pagination-page">...</span></li>`;
				paginationButtonsTpl += `<li><button class="banner-box__pagination-page" data-slide="${countSlides - 1}">${countSlides}</button></li>`;
			}
		}
		if (countSlides) {
			paginationTpl = `<ul>${paginationButtonsTpl}</ul>`;
		}
		$bannerPagination.html(paginationTpl);
	}
	if ($('.js-banner-slider').length) {
		splideBannerSlider = new Splide(".js-banner-slider", {
			type: 'loop',
			// drag: 'free',
			perPage: 1,
			perMove: 1,
			arrows: false,
			pagination: false,
			speed: 1000,
			easing: 'ease-in-out',
			autoplay: {
				delay: 2000,
			},
			// autoWidth: true,
			// pauseOnHover: false,
			// autoScroll: {
			// 	speed: 1,
			// 	pauseOnHover: false,
			// }
		});
		$('.banner-box__prev-button').on('click', () => {
			splideBannerSlider.go('<');
		});
		$('.banner-box__next-button').on('click', () => {
			splideBannerSlider.go('>');
		});
		$(document).on('click', '.banner-box__pagination-page', function() {
			const slideIndex = parseInt($(this).attr('data-slide'));
			splideBannerSlider.go(slideIndex);
		});
		function changeBannerContent() {
			const activeIndex = splideBannerSlider.index;
			const activeSlide = splideBannerSlider.Components.Slides.getAt(activeIndex); // Отримуємо активний слайд за індексом
			const $activeBannerSlide = activeSlide ? $(activeSlide.slide) : '';
			const $bannerTitle = $activeBannerSlide.find('.banner-hidden__title').html();
			const $bannerDate = $activeBannerSlide.find('.banner-hidden__date').html();
			const $bannerInfo = $activeBannerSlide.find('.banner-hidden__info').html();
			const $bannerButton = $activeBannerSlide.find('.banner-hidden__button').html();
			$('.banner-box__title').html($bannerTitle);
			$('.banner-box__date').html($bannerDate);
			$('.banner-box__info').html($bannerInfo);
			$('.banner-box__button').html($bannerButton);
			$('.banner-box__pagination-page').each(function() {
				$('.banner-box__pagination-page').removeClass('active');
				$(`.banner-box__pagination-page[data-slide="${activeIndex}"]`).addClass('active');
			});
		}
		splideBannerSlider.on( 'mounted', () => {
			// console.log('Splide був змонтований');
			initBannerPagination();
			changeBannerContent();
		}).on('move', (newIndex) => {
			// console.log('Активний слайд змінився на індекс: ', newIndex);
			initBannerPagination();
			changeBannerContent();
		});
		splideBannerSlider.mount();
	}

	/* - - - - - - - - - - - - - -       detect timerow years       - - - - - - - - - - - - - - - */
	function stickyElement($element) {
		const scrollTop = $(window).scrollTop();
		const $parent = $element.parent();

		const $header = $('.header-pac, .header-fgap');
		let headerTop = $header.innerHeight();
		let offsetTop = 0;
		if ($('body').hasClass('scroll-up') || scrollTop < $header.innerHeight()) {
			headerTop = $header.innerHeight();
			if (window.matchMedia("(max-width: 767px)").matches) {
				offsetTop = 8;
			} else {
				offsetTop = 16;
			}
		} else {
			headerTop = 0;
			if (window.matchMedia("(max-width: 767px)").matches) {
				offsetTop = 12;
			} else {
				offsetTop = 24;
			}
		}

		const posStart = headerTop + offsetTop;
		const elementTop = parseInt($element.offset().top - scrollTop - 1);
		const elementBottom = parseInt(elementTop + $parent.height() - $element.position().top + $element.innerHeight());
		if (elementTop <= posStart && posStart <= elementBottom) {
			$element.addClass('sticky');
		} else {
			$element.removeClass('sticky');
		}
	}
	if ($('.js-sticky').length) {
		$('.js-sticky').each(function() {
			const $element = $(this);
			stickyElement($element);
			$(window).on('scroll resize', () => stickyElement($element));
		});
	}

/* - - - - - - - - - - - - - -       init artist-exhibition slider       - - - - - - - - - - - - - - - */
const $artistExhibitionSliders = $('.js-artist-exhibition-slider');
if ($artistExhibitionSliders.length) {
		$artistExhibitionSliders.each(function (i) {
				const $currentSlider = $(this);
				const splideBannerSlider = new Splide($currentSlider[0], {
						type: 'loop',
						perPage: 1,
						perMove: 1,
						arrows: false,
						pagination: false,
						speed: 500,
						easing: 'ease',
				});

				const visiblePages = 4; // Always show 4 pagination items

				$('.artist-exhibition-box__prev-button').eq(i).on('click', function () {
						splideBannerSlider.go('<');
				});

				$('.artist-exhibition-box__next-button').eq(i).on('click', function () {
						splideBannerSlider.go('>');
				});

				$('.artist-exhibition-box__pagination').eq(i).on('click', function (event) {
						const $target = $(event.target);
						if ($target.hasClass('artist-exhibition-box__pagination-page')) {
								const slideIndex = parseInt($target.attr('data-slide'), 10);
								splideBannerSlider.go(slideIndex);
						}
				});

				function changeBannerContent() {
						const activeIndex = splideBannerSlider.index;
						const totalSlides = splideBannerSlider.length;

						updatePagination(activeIndex, totalSlides);

						const activeSlide = splideBannerSlider.Components.Slides.getAt(activeIndex);
						const $activeBannerSlide = $(activeSlide ? activeSlide.slide : null);

						if ($activeBannerSlide.length) {
								const bannerTitle = $activeBannerSlide.find('.artist-exhibition-hidden__title').html() || '';
								const bannerDescription = $activeBannerSlide.find('.artist-exhibition-hidden__description').html() || '';
								const bannerInfo = $activeBannerSlide.find('.artist-exhibition-hidden__info').html() || '';

								$('.artist-exhibition-box__title').eq(i).html(bannerTitle);
								$('.artist-exhibition-box__description').eq(i).html(bannerDescription);
								$('.artist-exhibition-box__info').eq(i).html(bannerInfo);
						}
				}

				function generatePagination(currentPage, totalPages) {
						let paginationButtonsTpl = '';

						if (totalPages <= visiblePages) {
								for (let i = 0; i < totalPages; i++) {
										paginationButtonsTpl += `<li><button class="artist-exhibition-box__pagination-page" data-slide="${i}">${i + 1}</button></li>`;
								}
						} else {
								if (currentPage <= 2) {
										for (let i = 0; i < visiblePages - 1; i++) {
												paginationButtonsTpl += `<li><button class="artist-exhibition-box__pagination-page" data-slide="${i}">${i + 1}</button></li>`;
										}
										paginationButtonsTpl += `<li><span class="pagination-dots">...</span></li>`;
										paginationButtonsTpl += `<li><button class="artist-exhibition-box__pagination-page" data-slide="${totalPages - 1}">${totalPages}</button></li>`;
								} else if (currentPage >= totalPages - 3) {
										paginationButtonsTpl += `<li><button class="artist-exhibition-box__pagination-page" data-slide="0">1</button></li>`;
										paginationButtonsTpl += `<li><span class="pagination-dots">...</span></li>`;
										for (let i = totalPages - (visiblePages - 1); i < totalPages; i++) {
												paginationButtonsTpl += `<li><button class="artist-exhibition-box__pagination-page" data-slide="${i}">${i + 1}</button></li>`;
										}
								} else {
										paginationButtonsTpl += `<li><button class="artist-exhibition-box__pagination-page" data-slide="0">1</button></li>`;
										paginationButtonsTpl += `<li><span class="pagination-dots">...</span></li>`;
										for (let i = currentPage - 1; i <= currentPage + 1; i++) {
												paginationButtonsTpl += `<li><button class="artist-exhibition-box__pagination-page" data-slide="${i}">${i + 1}</button></li>`;
										}
										paginationButtonsTpl += `<li><span class="pagination-dots">...</span></li>`;
										paginationButtonsTpl += `<li><button class="artist-exhibition-box__pagination-page" data-slide="${totalPages - 1}">${totalPages}</button></li>`;
								}
						}

						return paginationButtonsTpl;
				}

				function updatePagination(activeIndex, totalPages) {
						const $bannerPagination = $('.artist-exhibition-box__pagination').eq(i);
						const paginationTpl = `<ul>${generatePagination(activeIndex, totalPages)}</ul>`;
						$bannerPagination.html(paginationTpl);

						const $activeButton = $bannerPagination.find(`.artist-exhibition-box__pagination-page[data-slide="${activeIndex}"]`);
						$activeButton.addClass('active');
				}

				splideBannerSlider.on('mounted', function () {
						const countSlides = splideBannerSlider.length;
						updatePagination(0, countSlides);
						changeBannerContent();
				}).on('move', function () {
						changeBannerContent();
				});

				splideBannerSlider.mount();
		});
}

// Pagination with dots
function initSlider(sliderClass, containerSelector) {
	if ($(sliderClass).length) {
			$(sliderClass).each(function (index, element) {
					const splideBannerSlider = new Splide(element, {
							type: 'loop',
							perPage: 1,
							perMove: 1,
							arrows: false,
							pagination: false,
							speed: 500,
							easing: 'ease',
					});

					const $container = $(element).closest(containerSelector);
					const visiblePages = 4; // Always show 4 pagination items

					$container.find('.exhibition-tabs-slider-box__prev-button').on('click', () => {
							splideBannerSlider.go('<');
					});

					$container.find('.exhibition-tabs-slider-box__next-button').on('click', () => {
							splideBannerSlider.go('>');
					});

					$container.on('click', '.exhibition-tabs-slider-box__pagination-page', function () {
							const slideIndex = parseInt($(this).attr('data-slide'));
							splideBannerSlider.go(slideIndex);
					});

					function changeBannerContent() {
							const activeIndex = splideBannerSlider.index;
							const totalSlides = splideBannerSlider.length;

							updatePagination(activeIndex, totalSlides);
							$container.find('.exhibition-tabs-slider-box__pagination-page').removeClass('active');
							$container.find(`.exhibition-tabs-slider-box__pagination-page[data-slide="${activeIndex}"]`).addClass('active');
					}

					function generatePagination(currentPage, totalPages) {
							let paginationButtonsTpl = '';

							if (totalPages <= visiblePages) {
									for (let i = 0; i < totalPages; i++) {
											paginationButtonsTpl += `<li><button class="exhibition-tabs-slider-box__pagination-page" data-slide="${i}">${i + 1}</button></li>`;
									}
							} else {
									if (currentPage <= 2) {
											for (let i = 0; i < visiblePages - 1; i++) {
													paginationButtonsTpl += `<li><button class="exhibition-tabs-slider-box__pagination-page" data-slide="${i}">${i + 1}</button></li>`;
											}
											paginationButtonsTpl += `<li><span class="pagination-dots">...</span></li>`;
											paginationButtonsTpl += `<li><button class="exhibition-tabs-slider-box__pagination-page" data-slide="${totalPages - 1}">${totalPages}</button></li>`;
									} else if (currentPage >= totalPages - 3) {
											paginationButtonsTpl += `<li><button class="exhibition-tabs-slider-box__pagination-page" data-slide="0">1</button></li>`;
											paginationButtonsTpl += `<li><span class="pagination-dots">...</span></li>`;
											for (let i = totalPages - (visiblePages - 1); i < totalPages; i++) {
													paginationButtonsTpl += `<li><button class="exhibition-tabs-slider-box__pagination-page" data-slide="${i}">${i + 1}</button></li>`;
											}
									} else {
											paginationButtonsTpl += `<li><button class="exhibition-tabs-slider-box__pagination-page" data-slide="0">1</button></li>`;
											paginationButtonsTpl += `<li><span class="pagination-dots">...</span></li>`;
											for (let i = currentPage - 1; i <= currentPage + 1; i++) {
													paginationButtonsTpl += `<li><button class="exhibition-tabs-slider-box__pagination-page" data-slide="${i}">${i + 1}</button></li>`;
											}
											paginationButtonsTpl += `<li><span class="pagination-dots">...</span></li>`;
											paginationButtonsTpl += `<li><button class="exhibition-tabs-slider-box__pagination-page" data-slide="${totalPages - 1}">${totalPages}</button></li>`;
									}
							}

							return paginationButtonsTpl;
					}

					function updatePagination(activeIndex, totalPages) {
							const $bannerPagination = $container.find('.exhibition-tabs-slider-box__pagination');
							const paginationTpl = `<ul>${generatePagination(activeIndex, totalPages)}</ul>`;
							$bannerPagination.html(paginationTpl);

							// Set the active class on the correct pagination button after re-rendering
							$container.find(`.exhibition-tabs-slider-box__pagination-page[data-slide="${activeIndex}"]`).addClass('active');
					}

					splideBannerSlider.on('mounted', () => {
							const countSlides = splideBannerSlider.length;
							updatePagination(0, countSlides);
							changeBannerContent();
					}).on('move', () => {
							changeBannerContent();
					});

					splideBannerSlider.mount();
			});
	}
}

	// /* - - - - - - - - - - - - - -       init Exhibition at PinchukArtCentre 2021 slider       - - - - - - - - - - - - - - - */
	// /* - - - - - - - - - - - - - -       init ceremony slider       - - - - - - - - - - - - - - - */
initSlider('.js-exhibition-2021-slider', '.exhibition-tabs-slider');
initSlider('.js-ceremony-slider', '.exhibition-tabs-slider');


	/* - - - - - - - - - - - - - -       init exhibition slider       - - - - - - - - - - - - - - - */
	if ($('.js-exhibition-slider').length) {
		const splideExhibitionSlider = new Splide(".js-exhibition-slider", {
			type: 'false',
			// drag: 'free',
			perPage: 2,
			perMove: 1,
			arrows: true,
			pagination: false,
			speed: 500,
			easing: 'ease',
			// autoWidth: true,
			// pauseOnHover: false,
			// autoScroll: {
			// 	speed: 1,
			// 	pauseOnHover: false,
			// }
		});
		splideExhibitionSlider.mount();
	}

	/* - - - - - - - - - - - - - -       init works fancybox       - - - - - - - - - - - - - - - */
	// Fancybox.bind( '[data-fancybox]', {
	// 	autoFocus: false,
	// 	placeFocusBack: false,
	// 	dragToClose: false,
	// 	closeExisting: true,
	// 	tpl: {
	// 		closeButton: '<button data-fancybox-close class="f-button is-close-btn" title="{{CLOSE}}">' +
	// 			'<span class="icon icon-i-close"></span>' +
	// 			'</button>'
	// 	},
	// 	on: {
	// 		init: () => {
	// 			$( '.header-fgap-overflow' ).removeClass( 'show' );
	// 			$( '.header-pac-overflow' ).removeClass( 'show' );
	// 			$( 'body' ).removeClass( 'no-scroll' );
	// 			$( '.header-fgap-modal' ).removeClass( 'show' );
	// 			$( '.header-pac-modal' ).removeClass( 'show' );
	// 		},
	// 		close: ( fancybox ) => {
	//
	// 		}
	// 	}
	// });
	// if ($('.modal-works').length) {
	//
	// 	$(document).on('click', '.modal-works__arrow.prev', function() {
	// 		const worksInstance = Fancybox.getInstance();
	// 		worksInstance && worksInstance.prev();
	// 	});
	//
	// 	$(document).on('click', '.modal-works__arrow.next', function() {
	// 		const worksInstance = Fancybox.getInstance();
	// 		worksInstance && worksInstance.next();
	// 	});
	// }

	/* - - - - - - - - - - - - - -       init youtube thumbnail       - - - - - - - - - - - - - - - */
	if ($('.video-box').length) {
		$('.video-box').each(function () {
			setYoutubeThumbnail($(this));
		});
	}

	/* - - - - - - - - - - - - - -       video play       - - - - - - - - - - - - - - - */
	$(document).on('click', '.js-video-play', function() {
		const videoPlayButton = $(this);
		const videoBox = videoPlayButton.closest('.video-box');
		let video;
		let videoType = '';
		if (videoBox.find('video').length) {
			videoType = 'video';
		}
		if (videoBox.find('iframe').length) {
			videoType = 'iframe';
		}
		switch (videoType) {
			case 'video':
				video = videoBox.find('video').get(0);
				video.controls = true;
				video.muted = true;
				video.play();
				videoBox.addClass('playing');
				break;
			case 'iframe':
				video = videoBox.find('iframe').get(0);
				const videoSrc = videoBox.find('iframe').attr('src');
				const videoId = extractVideoId(videoSrc);
				if (!videoId) {
					alert('Unable to find video ID.');
					return;
				}
				const autoplayUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1`;
				video.src = autoplayUrl;
				setTimeout(() => {
					videoBox.addClass('playing');
				}, 1000)
				break;
			default: return;
		}
	});

	/* - - - - - - - - - - - - - -       init video slider       - - - - - - - - - - - - - - - */
	if ($('.js-video-slider').length) {
		const splideVideoSlider = new Splide(".js-video-slider", {
			type: 'false',
			// drag: 'free',
			perPage: 2,
			perMove: 1,
			arrows: true,
			pagination: false,
			speed: 500,
			easing: 'ease',
			// autoWidth: true,
			// pauseOnHover: false,
			// autoScroll: {
			// 	speed: 1,
			// 	pauseOnHover: false,
			// }
			breakpoints: {
				1199: {
					pagination: true,
				},
				991: {
					perPage: 1,
				},
			}
		});
		splideVideoSlider.mount();
	}

	if ($('.js-faq-toggle').length) {
		$('.js-faq-toggle').each(function() {
			const $this = $(this);
			const $parent = $this.closest('.faq-box');
			const $content = $parent.find('.faq-box__body');
			if ($parent.hasClass('show')) {
				$content.slideDown(250);
			} else {
				$content.slideUp(250);
			}
		});
	}
	$('.js-faq-toggle').on('click', function() {
		const $this = $(this);
		const $parent = $this.closest('.faq-box');
		const $content = $parent.find('.faq-box__body');
		if (!$parent.hasClass('show')) {
			$parent.addClass('show');
			$content.slideDown(250);
		} else {
			$parent.removeClass('show');
			$content.slideUp(250);
		}
	});

	/* - - - - - - - - - - - - - -       tggle plan box       - - - - - - - - - - - - - - - */
	$('.js-plans-drive').on('click', function() {
		const $this = $(this);
		const $list = $this.closest('.plans-list');
		const $parent = $this.closest('.plans-list__box');
		const $content = $parent.find('.plans-list__box-body');
		if (!$parent.hasClass('show')) {
			$list.find('.plans-list__box').removeClass('show');
			$parent.addClass('show');
			$list.find('.plans-list__box-body').slideUp(250);
			$content.slideDown(250);
		} else {
			$parent.removeClass('show');
			$content.slideUp(250);
		}
	});

	/* - - - - - - - - - - - - - -       toggle calendar slider       - - - - - - - - - - - - - - - */
	function toggleCalendarSlider() {
		if ($('.calendar .tabs').length) {
			if (typeof $('.tabs-list li a.active').attr('data-url') === 'undefined') {
				$('.js-calendar-slider').hide(0);
			} else {
				$('.js-calendar-slider').show(0);
			}
		}
	}
	toggleCalendarSlider();

	/* - - - - - - - - - - - - - -       init calendar slider       - - - - - - - - - - - - - - - */
	let currentCalendarDaysIndex = 0;
	function getCalendar(slider, link, direction = 'next') {
		$.ajax({
			url: link,
			method: 'GET',
			dataType: 'json',
			success: function (data) {
				if (data && data.length) {
					const splideCalendarList = slider.Components.Elements.list;
					while (splideCalendarList.firstChild) {
						splideCalendarList.removeChild(splideCalendarList.firstChild);
					}
					let startIndex = 0;
					if (direction === 'prev') {
						startIndex = data.length - 1;
					}
					if (direction === 'next') {
						startIndex = 0;
					}
					currentCalendarDaysIndex = startIndex;
					data.forEach((item, i) => {
						const div = document.createElement('div');
						div.className = 'splide__slide';
						div.innerHTML = item.html;
						splideCalendarList.appendChild(div);

						if ($(div).find('.calendar-box.active').length) {
							if (i === 0) {
								startIndex = i;
							} else {
								startIndex = i - 1;
							}
						}
						slider.refresh();
					});
					setTimeout(() => {
						slider.go(startIndex);
					}, 10);
					slider.Components.Arrows.arrows.prev.removeAttribute('disabled');
					slider.Components.Arrows.arrows.next.removeAttribute('disabled');

				}
			},
			error: function (xhr, status, error) {
				console.error('Помилка завантаження JSON:', error);
			}
		});
	}

	if ($('.js-calendar-slider').length) {
		const splideSelector = ".js-calendar-slider";
		const settingsCalendarSlider = {
			type: 'false',
			// drag: 'free',
			perPage: 8,
			perMove: 1,
			arrows: true,
			pagination: false,
			speed: 500,
			easing: 'ease',
			// autoWidth: true,
			dragMinThreshold: 1,
			breakpoints: {
				991: {
					perPage: 6,
				},
				767: {
					perPage: 5,
				},
				575: {
					perPage: 4,
				},
			}
		};
		let splideCalendarSlider = new Splide(splideSelector, settingsCalendarSlider);

		splideCalendarSlider.on('mounted', () => {
			splideCalendarSlider.Components.Elements.slides.forEach((slide, index) => {
				if ($(slide).find('.calendar-box.active').length) {
					currentCalendarDaysIndex = index;
				}
			});
			splideCalendarSlider.go(currentCalendarDaysIndex);
			setTimeout(() => {
				splideCalendarSlider.Components.Arrows.arrows.prev.removeAttribute('disabled');
				splideCalendarSlider.Components.Arrows.arrows.next.removeAttribute('disabled');
			}, 10);
		});

		// if ($('.calendar .tabs').length) {
		// 	if ($('.tabs-list li a.active').attr('data-url')) {
		// 		console.log(1)
		// 	}
		// }
		splideCalendarSlider.mount();

		const $splideCalendarSliderPrevButton = $(splideCalendarSlider.Components.Arrows.arrows.prev);
		const $splideCalendarSliderNextButton = $(splideCalendarSlider.Components.Arrows.arrows.next);
		$splideCalendarSliderPrevButton.on('click', function() {
			if (currentCalendarDaysIndex === 0) {
				getCalendar(splideCalendarSlider, '/calendar-days.json', 'prev');
			}
		});
		$splideCalendarSliderNextButton.on('click', function() {
			const currentPage = splideCalendarSlider.index;
			if (currentCalendarDaysIndex === currentPage) {
				getCalendar(splideCalendarSlider, '/calendar-days.json', 'next');
			}
		});

		splideCalendarSlider.on('move', (newIndex, oldIndex) => {
			if (currentCalendarDaysIndex === newIndex) {
				if (newIndex <= oldIndex) {
					getCalendar(splideCalendarSlider, '/calendar-days.json', 'prev');
				}
				if (newIndex > oldIndex) {
					getCalendar(splideCalendarSlider, '/calendar-days.json', 'next');
				}
			}
			setTimeout(() => {
				currentCalendarDaysIndex = newIndex;
			}, 10);
		});

		splideCalendarSlider.on('moved', () => {
			$splideCalendarSliderPrevButton.removeAttr('disabled');
			$splideCalendarSliderNextButton.removeAttr('disabled');
		});

		$('.js-calendar').on('click', function() {
			toggleCalendarSlider();
			const url = $(this).attr('data-url');
			if (typeof url === 'string' && url !== '') {
				getCalendar(splideCalendarSlider, url);
			} else {
				const splideCalendarList = splideCalendarSlider.Components.Elements.list;
				while (splideCalendarList.firstChild) {
					splideCalendarList.removeChild(splideCalendarList.firstChild);
				}
			}
		});
	}

	function setFilterSelectPosition() {
		const $this = $('.filter-select__title');
		const $select = $this.closest('.filter-select');
		const $list = $(`.filter-select__list[data-filter-select="${$this.attr('data-filter-select')}"]`);
		let isHidden = true;
		$list.find('.filter-box').each(function() {
			if (!$(this).hasClass('active')) {
				isHidden = false;
			}
		});
		if (isHidden) {
			$select.addClass('hidden');
		} else {
			$select.removeClass('hidden');
		}
		let posLeft = '';
		if ($this.offset().left + $this.innerWidth() < $(window).innerWidth()) {
			posLeft = $this.offset().left - ($list.innerWidth() - $this.innerWidth()) + 'px';
		}
		$list.css({
			top: $this.offset().top + $this.innerHeight() + 'px',
			left: posLeft,
		});
	}
	if ($('.filter-select').length) {
		$('.js-filter-select').on('click', function() {
			const $this = $(this);
			const $parent = $this.closest('.filter-select');
			const $list = $parent.find('.filter-select__list').detach();
			$('body').append($list);
			const $listDetach = $(`.filter-select__list[data-filter-select="${$this.attr('data-filter-select')}"]`);
			if (!$this.hasClass('active')) {
				$this.addClass('active');
				$listDetach.addClass('show');
				setFilterSelectPosition();
			} else {
				$this.removeClass('active');
				$listDetach.removeClass('show');
			}
		});
		$(window).on('resize', setFilterSelectPosition);
	}

	$(document).on('click', '.js-filter-box', function () {
		const $this = $(this);
		const $filterList = $this.closest('.filter-list');
		const $filterSelectList = $this.closest('.filter-select__list');
		$this.toggleClass('active');
		if ($filterSelectList.length) {
			// console.log('Filter select list');
			const filterSelectAttr = $filterSelectList.attr('data-filter-select');
			const $filterSelect = $(`.filter-select__title[data-filter-select="${filterSelectAttr}"]`).closest('.filter-select');
			$filterSelect.before($this.clone());
			$(`.filter-select__title[data-filter-select="${filterSelectAttr}"]`).removeClass('active');
			$filterSelectList.removeClass('show');
		} else {
			// console.log('Filter list');
			const filterSelectAttr = $filterList.find('.filter-select__title').attr('data-filter-select');
			if ($this.is('[data-filter-option]')) {
				// const $filterSelect = $(`.filter-select__title[data-filter-select="${filterSelectAttr}"]`).closest('.filter-select');
				$(`.filter-select__list[data-filter-select="${filterSelectAttr}"]`).find(`[data-filter-option=${$this.attr('data-filter-option')}]`).removeClass('active');
				$this.remove();
			}
		}
		setFilterSelectPosition();
	});

	$(document).on('click', (e) => {
		if (!$(e.target).closest('.filter-select').length && !$(e.target).closest('.filter-select__list').length) {
			$('.filter-select__title').removeClass('active');
			$('.filter-select__list').removeClass('show');
		}
	});

	/* - - - - - - - - - - - - - -       toggle timerow years select       - - - - - - - - - - - - - - - */
	$('.js-timerow-years-select').on('click', function() {
		const $parent = $(this).closest('.timerow-years-select');
		if (!$parent.hasClass('show')) {
			$parent.addClass('show');
		} else {
			$parent.removeClass('show');
		}
	});
	$(document).on('click', (e) => {
		if (!$(e.target).closest('.timerow-years-select').length) {
			$('.timerow-years-select').removeClass('show');
		}
	});

	/* - - - - - - - - - - - - - -       set prize category height       - - - - - - - - - - - - - - - */
	function setPrizeCategoryHeight() {
		let maxHeight = 0;
		$('.prize-category__box').each(function () {
			const $this = $(this);
			const $title = $this.find('.prize-category__box-title');
			$title.css('height', '');
			if ($title.innerHeight() > 0) {
				maxHeight = $title.innerHeight();
			}
		});
		if (window.matchMedia('(min-width: 1200px)').matches) {
			$('.prize-category__box-title').css('height', maxHeight);
		} else {
			$('.prize-category__box-title').css('height', '');
		}
	}
	if ($('.prize-category__box').length) {
		setPrizeCategoryHeight();
		$(window).on('resize', setPrizeCategoryHeight);
	}

	/* - - - - - - - - - - - - - -       set prize shortlist height       - - - - - - - - - - - - - - - */
	function setPrizeShortlistHeight() {
		let maxHeight = 0;
		let colCount = 1;
		if (window.matchMedia('(min-width: 576px)').matches) {
			if (window.matchMedia('(min-width: 1200px)').matches) {
				colCount = 4;
			} else {
				colCount = 2;
			}
		}
		$('.prize-shortlist__grid').each(function () {
			const $grid = $(this);
			const $boxes = $grid.find('.prize-shortlist__box');
			$boxes.find('.prize-shortlist__box-title').css('height', '');
			for (let i = 0; i < $boxes.length; i += colCount) {
				let maxHeightInRow = 0;
				const $rowBoxes = $boxes.slice(i, i + colCount);
				$rowBoxes.each(function () {
					const $box = $(this);
					const $title = $box.find('.prize-shortlist__box-title');
					if ($title.innerHeight() > maxHeightInRow) {
						maxHeightInRow = $title.innerHeight();
					}
				});
				$rowBoxes.find('.prize-shortlist__box-title').css('height', maxHeightInRow);
			}
		});
	}
	if ($('.prize-shortlist__box').length) {
		setPrizeShortlistHeight();
		$(window).on('resize', setPrizeShortlistHeight);
	}

	/* - - - - - - - - - - - - - -       init pac prize news slider       - - - - - - - - - - - - - - - */
	if ($('.js-prize-news-slider').length) {
		const splidePrizeNewsSlider = new Splide(".js-prize-news-slider", {
			type: 'false',
			// drag: 'free',
			perPage: 3,
			perMove: 1,
			arrows: true,
			pagination: false,
			speed: 500,
			easing: 'ease',
			// autoWidth: true,
			// pauseOnHover: false,
			// autoScroll: {
			// 	speed: 1,
			// 	pauseOnHover: false,
			// }
			breakpoints: {
				1199: {
					perPage: 2,
				},
				767: {
					perPage: 1,
				},
			}
		});
		splidePrizeNewsSlider.mount();
	}

	/* - - - - - - - - - - - - - -       init research books slider       - - - - - - - - - - - - - - - */
	if ($('.js-research-books-slider').length) {
		const splideReasearchBooksSlider = new Splide(".js-research-books-slider", {
			type: 'false',
			// drag: 'free',
			perPage: 2,
			perMove: 2,
			arrows: true,
			pagination: false,
			speed: 500,
			easing: 'ease',
			// autoWidth: true,
			// pauseOnHover: false,
			// autoScroll: {
			// 	speed: 1,
			// 	pauseOnHover: false,
			// }
			breakpoints: {
				1199: {
					arrows: false,
					pagination: true,
				},
				991: {
					perPage: 1,
					perMove: 1,
				}
			}
		});
		splideReasearchBooksSlider.mount();
	}

	/* - - - - - - - - - - - - - -       init research exhibitions slider       - - - - - - - - - - - - - - - */
	if ($('.js-research-exhibitions-slider').length) {
		const splideResearchExhibitionsSlider = new Splide(".js-research-exhibitions-slider", {
			type: 'false',
			// drag: 'free',
			perPage: 2,
			perMove: 1,
			arrows: true,
			pagination: false,
			speed: 500,
			easing: 'ease',
			// autoWidth: true,
			// pauseOnHover: false,
			// autoScroll: {
			// 	speed: 1,
			// 	pauseOnHover: false,
			// }
			breakpoints: {
				1199: {
					pagination: true,
				},
				767: {
					perPage: 1,
				}
			}
		});
		splideResearchExhibitionsSlider.mount();
	}

	/* - - - - - - - - - - - - - -       init research exhibitions slider       - - - - - - - - - - - - - - - */
	let splideActionEventsSlider;
	function handleActionEventsSlider() {
		if (splideActionEventsSlider) {
			splideActionEventsSlider.destroy();
			splideActionEventsSlider = null;
			$('.js-action-modal-events').removeClass('is-initialized');
		}

		if (window.matchMedia('(max-width: 767px)').matches) {
			splideActionEventsSlider = new Splide(".js-action-modal-events", {
				type: 'false',
				// drag: 'free',
				perPage: 1,
				perMove: 1,
				arrows: false,
				pagination: true,
				speed: 500,
				easing: 'ease',
			});
			splideActionEventsSlider.mount();
		}
	}
	if ($('.js-action-modal-events').length) {
		handleActionEventsSlider();
		$(window).on('resize', handleActionEventsSlider);
	}

	/* - - - - - - - - - - - - - -       init research accordion       - - - - - - - - - - - - - - - */
	function researchAccordion() {
		$('.research-accordion__box').each(function () {
			const $this = $(this);
			const $content = $this.find('.research-accordion__box-body');
			if ($this.hasClass('show')) {
				$content.slideDown(250);
			} else {
				$content.slideUp(250);
			}
		});
	}
	if ($('.js-research-accordion').length) {
		researchAccordion();
	}
	$('.js-research-accordion').on('click', function () {
		const $this = $(this);
		const $parent = $this.closest('.research-accordion__box');
		const $content = $parent.find('.research-accordion__box-body');
		if (!$parent.hasClass('show')) {
			// $('.research-accordion__box').removeClass('show');
			// $('.research-accordion__box-body').slideUp(250);
			$parent.addClass('show');
			$content.slideDown(250);
		} else {
			$parent.removeClass('show');
			$content.slideUp(250);
		}
	});

	/* - - - - - - - - - - - - - -       toggle text       - - - - - - - - - - - - - - - */
	if ($('.js-text').length) {
		$('.js-text').each(function () {
			if ($(this).is('[data-letters]')) {
				setTextHeight($(this));
			}
		});
	}

	/* - - - - - - - - - - - - - -       toggle research publication       - - - - - - - - - - - - - - - */
	if ($('.js-research-publications-grid').length) {
		$('.js-research-publications-grid').each(function () {
			researchPublicationGrid($(this));
		});

		let width = $(window).innerWidth();
		$(window).on('resize', function() {
			if ($(window).innerWidth() !== width) {
				width = $(window).innerWidth();
				$('.js-research-publications-grid').each(function () {
					researchPublicationGrid($(this));
				});
			}
		});
	}

	/* - - - - - - - - - - - - - -       init research other slider       - - - - - - - - - - - - - - - */
	if ($('.js-research-other-slider').length) {
		const splideResearchExhibitionsSlider = new Splide(".js-research-other-slider", {
			type: 'false',
			// drag: 'free',
			perPage: 4,
			perMove: 1,
			arrows: true,
			pagination: false,
			speed: 500,
			easing: 'ease',
			// autoWidth: true,
			// pauseOnHover: false,
			// autoScroll: {
			// 	speed: 1,
			// 	pauseOnHover: false,
			// }
			breakpoints: {
				1199: {
					perPage: 2,
					pagination: true,
				},
				575: {
					perPage: 1,
				}
			}
		});
		splideResearchExhibitionsSlider.mount();
	}

	/* - - - - - - - - - - - - - -       rebuild research page       - - - - - - - - - - - - - - - */
	function rebuildResearchPage() {
		const isHorizontal = $('.research-page__img.is-horizontal').length ? true : false;
		const isVertical = $('.research-page__img.is-vertical').length ? true : false;
		const $researchPageImgHorizontal = $('.research-page__img.is-horizontal').detach();
		const $researchPageImgVertical = $('.research-page__img.is-vertical').detach();
		const $researchPageSidebar = $('.research-page__sidebar').detach();
		if (isVertical) {
			const $researchPageHeadline = $('.research-page__headline').detach();
			if (window.matchMedia('(max-width: 1199px)').matches) {
				$('.research-page__inner').before($researchPageHeadline);
			} else {
				$('.research-page__content').prepend($researchPageHeadline);
			}
		}
		if (window.matchMedia('(max-width: 1199px)').matches) {
			$('.research-page__text').before($researchPageSidebar);
			$('.research-page__content').prepend($researchPageImgHorizontal);
			$('.research-page__content').prepend($researchPageImgVertical);
		} else {
			$('.research-page__inner').append($researchPageSidebar);
			$('.research-page__inner').prepend($researchPageImgHorizontal);
			$('.research-page__sidebar').prepend($researchPageImgVertical);
		}
	}
	if ($('.research-page__inner').length) {
		rebuildResearchPage();
		$(window).on('resize', rebuildResearchPage);
	}

	/* - - - - - - - - - - - - - -       init research sidebar accordion       - - - - - - - - - - - - - - - */
	function researchSidebarAccordion() {
		$('.research-sidebar__accordion-box').each(function () {
			const $this = $(this);
			const $content = $this.find('.research-sidebar__accordion-body');
			if ($this.hasClass('show')) {
				$content.slideDown(250);
			} else {
				$content.slideUp(250);
			}
		});
	}
	if ($('.js-research-sidebar-accordion').length) {
		researchSidebarAccordion();
	}
	$(document).on('click', '.js-research-sidebar-accordion', function () {
		const $this = $(this);
		const $parent = $this.closest('.research-sidebar__accordion-box');
		const $content = $parent.find('.research-sidebar__accordion-body');
		if (!$parent.hasClass('show')) {
			$parent.addClass('show');
			$content.slideDown(250);
		} else {
			$parent.removeClass('show');
			$content.slideUp(250);
		}
	});

	/* - - - - - - - - - - - - - -       init research artworks slider       - - - - - - - - - - - - - - - */
	if ($('.js-research-artworks-slider').length) {
		const splideResearchArtworksSlider = new Splide(".js-research-artworks-slider", {
			type: 'loop',
			// drag: 'free',
			perPage: 1,
			perMove: 1,
			arrows: false,
			pagination: false,
			speed: 1000,
			easing: 'ease-in-out',
			// autoWidth: true,
			// pauseOnHover: false,
			// autoScroll: {
			// 	speed: 1,
			// 	pauseOnHover: false,
			// }
		});
		$('.research-artworks__banner-prev-button').on('click', () => {
			splideResearchArtworksSlider.go('<');
		});
		$('.research-artworks__banner-next-button').on('click', () => {
			splideResearchArtworksSlider.go('>');
		});
		$(document).on('click', '.research-artworks__banner-pagination-page', function() {
			const slideIndex = parseInt($(this).attr('data-slide'));
			splideResearchArtworksSlider.go(slideIndex);
		});
		function changeResearchArtworksContent() {
			const activeIndex = splideResearchArtworksSlider.index;
			const activeSlide = splideResearchArtworksSlider.Components.Slides.getAt(activeIndex); // Отримуємо активний слайд за індексом
			const $activeResearchArtworksSlide = activeSlide ? $(activeSlide.slide) : '';
			const $researchArtworksTitle = $activeResearchArtworksSlide.find('.research-artworks__hidden-title').html();
			const $researchArtworksInfo = $activeResearchArtworksSlide.find('.research-artworks__hidden-info').html();
			$('.research-artworks__banner-title').html($researchArtworksTitle);
			$('.research-artworks__banner-info').html($researchArtworksInfo);
			$('.research-artworks__banner-pagination-page').each(function() {
				$('.research-artworks__banner-pagination-page').removeClass('active');
				$(`.research-artworks__banner-pagination-page[data-slide="${activeIndex}"]`).addClass('active');
			});
		}
		splideResearchArtworksSlider.on( 'mounted', () => {
			// console.log('Splide був змонтований');
			const $researchArtworksPagination = $('.research-artworks__banner-pagination');
			const countSlides = splideResearchArtworksSlider.length;
			let paginationTpl = '';
			let paginationButtonsTpl = '';
			for (let i = 0; i < countSlides; i++) {
				paginationButtonsTpl += `<li><button class="research-artworks__banner-pagination-page" data-slide="${i}">${i+1}</button></li>`;
			}
			if (countSlides) {
				paginationTpl = `<ul>${paginationButtonsTpl}</ul>`;
			}
			$researchArtworksPagination.html(paginationTpl);
			changeResearchArtworksContent();
		}).on('move', (newIndex) => {
			// console.log('Активний слайд змінився на індекс: ', newIndex);
			changeResearchArtworksContent();
		});
		splideResearchArtworksSlider.mount();
	}

	/* - - - - - - - - - - - - - -       scroll to research filter       - - - - - - - - - - - - - - - */
	function scrollToResearchFilter() {
		const $researchFilter = $('.research-filter');
		let headerHeight = 0;
		if ($('.research-filter').offset().top < $(window).scrollTop()) {
			headerHeight = $('.header-pac, .header-prize, .header-fgap').innerHeight();
		}
		const scrollTo = $researchFilter.offset().top - headerHeight - 24;
		if (location.search !== '') {
			$('html, body').animate({scrollTop: scrollTo}, 250);
		}
	}
	if ($('.research-filter').length) {
		scrollToResearchFilter();
	}

	/* - - - - - - - - - - - - - -       init pac prize artworks slider       - - - - - - - - - - - - - - - */
	if ($('.js-prize-artworks-slider').length) {
		const splidePrizeNewsSlider = new Splide(".js-prize-artworks-slider", {
			type: 'false',
			// drag: 'free',
			perPage: 1,
			perMove: 1,
			arrows: true,
			pagination: false,
			speed: 500,
			easing: 'ease',
			breakpoints: {
				1199: {
					arrows: false,
					pagination: true,
				},
			}
		});
		splidePrizeNewsSlider.mount();
	}

	function setPrizeTimelineHeight() {
		let maxHeight = 0;
		const $prizeTimelineLine = $('.prize-timeline__line');
		$('.prize-timeline__box').each(function () {
			const $this = $(this);
			const $title = $this.find('.prize-timeline__box-title');
			$title.css('height', '');
			if ($title.innerHeight() > maxHeight) {
				maxHeight = $title.innerHeight();
			}
		});
		if (window.matchMedia('(min-width: 1200px)').matches) {
			$prizeTimelineLine.css('top', `${maxHeight + 66}px`);
			$('.prize-timeline__box-title').css('height', maxHeight);
		} else {
			$prizeTimelineLine.css('top', '');
			$('.prize-timeline__box-title').css('height', '');
		}
	}
	if($('.prize-timeline__box').length) {
		setPrizeTimelineHeight();
		$(window).on('resize', setPrizeTimelineHeight);
	}

	/* - - - - - - - - - - - - - -       init exhibition slider       - - - - - - - - - - - - - - - */
	if ($('.js-modal-works-slider').length) {
		$('.js-modal-works-slider').each(function() {
			const $slider = $(this)[0];
			const splideModalWorksSlider = new Splide($slider, {
				type: 'slide',
				// drag: 'free',
				perPage: 1,
				perMove: 1,
				arrows: false,
				pagination: false,
				speed: 500,
				easing: 'ease',
				// autoWidth: true,
				// pauseOnHover: false,
				// autoScroll: {
				// 	speed: 1,
				// 	pauseOnHover: false,
				// }
			});
			const $modal = $(this).closest('.modal');
			splideModalWorksSlider.on('mounted', () => {
				if (splideModalWorksSlider.length < 2) {
					$modal.find('.modal-works__arrow').hide();
				}
			});
			$modal.find('.modal-works__arrow.prev').on('click', () => {
				splideModalWorksSlider.go('<');
			});
			$modal.find('.modal-works__arrow.next').on('click', () => {
				splideModalWorksSlider.go('>');
			});
			splideModalWorksSlider.mount();
		});
	}

	/* - - - - - - - - - - - - - -       init slider-mini       - - - - - - - - - - - - - - - */
	document.querySelectorAll('.js-slider-one').forEach((sliderEl) => {
		const splide = new Splide(sliderEl, {
			type: 'false',
			perPage: 1,
			perMove: 1,
			arrows: true,
			pagination: false,
			speed: 500,
			easing: 'ease',
			gap: '24px',
			breakpoints: {
				1199: {
					perPage: 1,
					gap: '0px',
					arrows: false,
					pagination: true,
				},
			}
		});
		splide.mount();
	});
	/* - - - - - - - - - - - - - -       init slider-two       - - - - - - - - - - - - - - - */
	document.querySelectorAll('.js-slider-two').forEach((sliderEl) => {
		const splide = new Splide(sliderEl, {
			type: 'false',
			perPage: 2,
			perMove: 1,
			arrows: true,
			pagination: false,
			speed: 500,
			easing: 'ease',
			breakpoints: {
				1199: {
					perPage: 1,
					arrows: false,
					pagination: true,
				},
			}
		});
		splide.mount();
	});

	/* - - - - - - - - - - - - - -       init slider-two-videos      - - - - - - - - - - - - - - - */
	document.querySelectorAll('.js-slider-two-videos').forEach((sliderEl) => {
		const splide = new Splide(sliderEl, {
			type: 'false',
			perPage: 2,
			perMove: 1,
			arrows: true,
			pagination: false,
			speed: 500,
			easing: 'ease',
			breakpoints: {
				1199: {
					perPage: 1,
					arrows: false,
					pagination: true,
				},
			}
		});
		splide.mount();
	});

	/* - - - - - - - - - - - - - -       init slider-three-videos      - - - - - - - - - - - - - - - */
	document.querySelectorAll('.js-slider-three-publications').forEach((sliderEl) => {
		const splide = new Splide(sliderEl, {
			type: 'slide',
			perPage: 3,
			perMove: 1,
			gap: '24px',
			arrows: true,
			pagination: false,
			speed: 500,
			easing: 'ease',
			breakpoints: {
				1199: {
					perPage: 2,
					gap: '0px',
					arrows: false,
					pagination: true,
				},
				767: {
					perPage: 1,
				}
			}
		});
		splide.mount();
	});
	/* - - - - - - - - - - - - - -       init slider-three       - - - - - - - - - - - - - - - */
	document.querySelectorAll('.js-slider-three').forEach((sliderEl) => {
		const splide = new Splide(sliderEl, {
			type: 'slide',
			perPage: 3,
			perMove: 1,
			arrows: true,
			pagination: false,
			speed: 500,
			gap: '24px',
			easing: 'ease',
			breakpoints: {
				1199: {
					perPage: 2,
					gap: '0px',
					arrows: false,
					pagination: true,
				},
				767: {
					perPage: 1,
				}
			}
		});
		splide.mount();
	});

	/* - - - - - - - - - - - - - -       init slider-photogallery     - - - - - - - - - - - - - - - */
	let splidePhotogallerySlider;

	if (document.querySelector('.js-slider-photogallery')) {
		splidePhotogallerySlider = new Splide('.js-slider-photogallery', {
			type: 'fade',
			rewind: true,
			perPage: 1,
			perMove: 1,
			arrows: true,
			pagination: false,
			speed: 500,
			easing: 'ease',
		});
		splidePhotogallerySlider.mount();
	}

	document.querySelectorAll('.photogallery-list .item').forEach((item) => {
		item.addEventListener('click', function () {
			const index = parseInt(this.getAttribute('data-index'));
			const modal = document.getElementById('modal-photogallery');

			if (modal) {
				modal.style.display = 'block';

				if (!isNaN(index) && splidePhotogallerySlider) {
					splidePhotogallerySlider.refresh();
					splidePhotogallerySlider.go(index, true);
				}
			}
		});
	});


	/* - - - - - - - - - - - - - -       code copy       - - - - - - - - - - - - - - - */
	$(document).on('click', '.code-copy', function () {
		const button = $(this);
		const wrapper = button.closest('.content-copy-info');
		const tooltip = wrapper.find('.item-tooltip');
		const textToCopy = button.data('copy');

		if (textToCopy) {
			navigator.clipboard.writeText(textToCopy).then(() => {
				tooltip.addClass('visible');

				setTimeout(() => {
					tooltip.removeClass('visible');
				}, 2000);
			});
		}
	});

	/* - - - - - - - - - - - - - -       news list mob       - - - - - - - - - - - - - - - */

	function updateMobList() {
		const isMobile = $(window).width() < 768;
		$('.news-all-page .list').each(function() {
			if (isMobile) {
				$(this).addClass('mob-list');
			} else {
				$(this).removeClass('mob-list');
			}
		});
	}
	$(document).ready(updateMobList);
	$(window).on('resize', updateMobList);

	/* - - - - - - - - - - - - - -       cards Cols       - - - - - - - - - - - - - - - */
	window.initResponsiveColumns = function(wrapperSelector, itemSelector = '.events-block') {
		$(wrapperSelector).each(function () {
			const $wrapper = $(this);
			const $originalCards = $wrapper.find(itemSelector).clone();
			let currentCols = getCols();

			initCols($wrapper, $originalCards);

			const resizeNamespace = 'resize.initResponsiveColumns_' + Math.random().toString(36).substr(2, 5);

			$(window).off('.' + resizeNamespace).on(resizeNamespace, function () {
				const newCols = getCols();
				if (newCols !== currentCols) {
					currentCols = newCols;
					initCols($wrapper, $originalCards.clone());
				}
			});
		});

		function getCols() {
			const width = $(window).width();
			if (width > 1199) return 3;
			if (width > 767) return 2;
			return 1;
		}

		function initCols($list, $cards) {
			const cols = getCols();
			$list.empty();

			for (let i = 0; i < cols; i++) {
				$list.append('<div class="events__list"></div>');
			}

			const $listColumns = $list.find('.events__list');

			const sortedCards = $cards.get().sort((a, b) => {
				const indexA = parseInt($(a).data('index'), 10);
				const indexB = parseInt($(b).data('index'), 10);
				return indexA - indexB;
			});

			$.each(sortedCards, function (i, card) {
				const col = i % cols;
				$listColumns.eq(col).append(card);
			});
		}
	};

	Object.assign(window, {
		initSelect,
		initYearRangeDatepickerAll
	});

	window.initResponsiveColumns('.events__wrapper');

	/* - - - - - - - - - - - - - -       video btn trigger       - - - - - - - - - - - - - - - */
	const videoBtns = document.querySelectorAll('.js-video-play-btn');
	const videos = document.querySelectorAll('.js-video-wrapper .js-video');

	// videos?.forEach(video => video.pause());

	if (videos) {
		videos.forEach(video => video.pause());
	}

	videoBtns.forEach(btn => {
		btn.addEventListener('click', (e) => {
			const video = e.target.closest('.js-video-wrapper').querySelector('.js-video');
			video.play();
			video.setAttribute('controls', 'controls');
			btn.style.display = 'none';
		})
	})

	initEventsGrid();
	initWorksGrid();
	initExhibitionsGrid();
	initResearchArchiveGrid();
	initResearchPublicationGrid();
	initResearchInstitutionGrid();
	initPrizeWorksGrid();

	// Sticky years Slider on the fgap-past page START
	if ($('.js-timerow-years-slider').length) {
		const splideExhibitionYearsSlider = new Splide(".js-timerow-years-slider", {
			type: 'false',
			// drag: 'free',
			perPage: 5,
			perMove: 1,
			arrows: true,
			pagination: false,
			speed: 500,
			easing: 'ease',
			autoWidth: true,
			// pauseOnHover: false,
			// autoScroll: {
			// 	speed: 1,
			// 	pauseOnHover: false,
			// }
			breakpoints: {
				767: {
					perPage: 3,
				},
			}
		});
		splideExhibitionYearsSlider.mount();
	}
	const slides = document.querySelectorAll('.timerow-years-slide');
	const prevBtn = document.querySelector('.timerow-years-btn.prev-btn');
	const nextBtn = document.querySelector('.timerow-years-btn.next-btn');

	let activeIndex = [...slides].findIndex(item => item.classList.contains('active'));

	function updateActiveSlide() {
		slides.forEach((slide, index) => {
			slide.classList.toggle('active', index === activeIndex);
		});
	}

	// prevBtn?.addEventListener('click', () => {
	// 	activeIndex = (activeIndex - 1 + slides.length) % slides.length;
	// 	updateActiveSlide();
	// });

	// nextBtn?.addEventListener('click', () => {
	// 	activeIndex = (activeIndex + 1) % slides.length;
	// 	updateActiveSlide();
	// });

	if (prevBtn) {
		prevBtn.addEventListener('click', () => {
			activeIndex = (activeIndex - 1 + slides.length) % slides.length;
			updateActiveSlide();
		});
	}

	if (nextBtn) {
		nextBtn.addEventListener('click', () => {
			activeIndex = (activeIndex + 1) % slides.length;
			updateActiveSlide();
		});
	}


	slides.forEach((slide, index) => {
    slide.addEventListener('click', () => {
        activeIndex = index;
        updateActiveSlide();
    });

});

	updateActiveSlide();
// Sticky years Slider on the fgap-past page END

});

document.addEventListener("DOMContentLoaded", () => {
	showHideReadMoreButton();
	const readMoreBlocks = document.querySelectorAll('[data-read-more]');

	if (readMoreBlocks.length) {
		readMoreBlocks.forEach(item => {
			const readMoreContent = item.querySelector('.js-read-more-content');
			const readMoreBtn = item.querySelector('.js-read-more-btn');

			let readMoreLabel = '';
			let readLessLabel = '';

			if (readMoreBtn) {
				readMoreLabel = readMoreBtn.getAttribute("data-more-label");
				readLessLabel = readMoreBtn.getAttribute("data-less-label");
			}

			if (readMoreBtn && readMoreContent) {
				readMoreBtn.addEventListener('click', () => {
					const isCollapsed = readMoreContent.classList.contains('collapsed');
					const scrollInner = readMoreContent.querySelector('.scroll');
					const reedMoreTitle = readMoreContent.querySelector('.title');
					const reedMoreText = readMoreContent.querySelector('.text');
					let offsetTop = 0;
					if (reedMoreTitle) {
						const reedMoreTitleStyle = window.getComputedStyle(reedMoreTitle);
						offsetTop = reedMoreTitle.scrollHeight + parseInt(parseInt(reedMoreTitleStyle.marginTop, 10)) + parseInt(parseInt(reedMoreTitleStyle.marginBottom, 10))
					}

					// Перемикаємо клас
					readMoreContent.classList.toggle('collapsed');

					// Оновлюємо текст кнопки
					readMoreBtn.textContent = isCollapsed ? readMoreLabel : readLessLabel;

					if (reedMoreText) {
						scrollInner.style.maxHeight = isCollapsed ? '' : `${reedMoreText.scrollHeight + offsetTop}px`;
					}

					// Якщо зараз розгортається (було collapsed, тепер ні)
					if (isCollapsed) {
						if (scrollInner) scrollInner.scrollTop = 0;

						const $parent = $(readMoreBtn).closest('.about-tabs');
						if ($parent.length) {
							const top = $(window).scrollTop();
							const posTop = $parent.closest('.section').offset().top - 24;
							const headerHeight = $('.header-pac, .header-fgap').length ? $('.header-pac, .header-fgap').innerHeight() : 0;
							let scrollTo = top > posTop ? posTop - headerHeight : posTop;
							$('html, body').animate({scrollTop: scrollTo}, 250);
						}
					}
				});
			}
		});
	}

	// Header shrinking on scroll
	const header = document.querySelector('.header-fgap-top');
	document.addEventListener('scroll', () => {
		const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
		if (header) {
			if (scrollTop > 300) {
				header.classList.add('shrunk');
			} else {
				header.classList.remove('shrunk');
			}
		}
	});
});

{
	let splides = [];

  function initCardsSplides() {
    const sliders = document.querySelectorAll('.js-cards-body-slider');

    sliders.forEach((slider, index) => {
      // Check if slider is already initialized
      if (!splides[index]) {
        if (window.innerWidth < 768) {
          splides[index] = new Splide(slider, {
            type: 'slide',
            autoWidth: true,
            gap: '16px',
            padding: '16px',
            pagination: false,
            arrows: false,
            drag: 'free',
          }).mount();
        }
      } else {
        // Destroy if window width >= 768
        if (window.innerWidth >= 768) {
          splides[index].destroy();
          splides[index] = null;
        }
      }
    });
  }

  window.addEventListener('load', initCardsSplides);
  window.addEventListener('resize', initCardsSplides);
}

{
	let splides = [];

	function initPrizesSplides() {
		const sliders = document.querySelectorAll('.js-prize-cards-slider');

		sliders.forEach((slider, index) => {
			// Destroy existing slider instance if it exists
			if (splides[index]) {
				splides[index].destroy();
				splides[index] = null;
			}

			// Reset any inline styles that may persist
			const track = slider.querySelector('.splide__list');
			if (track) {
				track.style.transform = '';
				track.style.gap = '';
			}

			// Base slider options
			let options = {
				type: 'slide',
				autoWidth: true,
				gap: '24px',
				pagination: false,
				arrows: true,
				drag: 'free'
			};

			// Adjust padding based on window width
			const width = window.innerWidth;
			if (width > 1279) {
				options.padding = '40px';
			} else if (width <= 1279 && width > 1248) {
				options.padding = `${(width - 1200) / 2}px`;
			} else if (width <= 1248 && width > 767) {
				options.padding = '24px';
			} else {
				options.gap = '16px';
				options.padding = '16px';
			}

			splides[index] = new Splide(slider, options);

			splides[index].on('mounted', () => {
				const arrows = slider.querySelector('.splide__arrows');
				const isOverflow = !splides[index].Components.Layout.isOverflow();

				arrows.classList[!isOverflow ? 'remove' : 'add']('splide--no-arrows');
			});

			splides[index].mount();
		});
	}

	window.addEventListener('load', initPrizesSplides);
	window.addEventListener('resize', initPrizesSplides);
}

$('#check_all').on('change', function () {
	const isChecked = this.checked;
	$('.table-responsive table tbody tr').each(function () {
		const $checkbox = $(this).find('input[type="checkbox"]');

		if (isChecked) {
			$checkbox.prop('checked', true).attr('checked', 'checked');
			$(this).addClass('selected_row');
		} else {
			$checkbox.prop('checked', false).removeAttr('checked');
			$(this).removeClass('selected_row');
		}
	});
});

$(document).ready(function () {
	const minGroupHeight = parseFloat(getComputedStyle(document.documentElement).fontSize) * 11.875;

	$('.submission-profile__group.bio-text').each(function () {
		const $group = $(this);
		const $button = $group.find('.submission-profile_more');

		$button.toggleClass('hide', $group.outerHeight() < minGroupHeight);
	});

	$('a.show-selected').on('click', function (e) {
    	e.preventDefault();

    	const $button = $(this);
    	const $selected = $('#selected');

    	$button.toggleClass('active');
    	$selected.slideToggle(200);
	});

	$('.submission-profile_more').on('click', function () {
		const $button = $(this);
		const $group = $button.closest('.submission-profile__group');
		const $rows = $group.find('.submission-profile__flex-wrap:not(.folded-visible)');

		$group.toggleClass( 'expanded' )
		$rows.addClass( 'clicked' )

		if ($group.hasClass('expanded')) {
			$rows.slideDown();
			var labelText = $button.data('less');
			$button.html(labelText + ' <span class="icon icon-i-arr-long-down"></span>');
		} else {
			$rows.slideUp()

			var labelText = $button.data('more');
			$button.html( labelText + ' <span class="icon icon-i-arr-long-down"></span>');
		}
	});

});


$('#check_all').on('change', function () {
	const isChecked = this.checked;
	$('.table-responsive table tbody tr').each(function () {
		const $checkbox = $(this).find('input[type="checkbox"]');

		if (isChecked) {
			$checkbox.prop('checked', true).attr('checked', 'checked');
			$(this).addClass('selected_row');
		} else {
			$checkbox.prop('checked', false).removeAttr('checked');
			$(this).removeClass('selected_row');
		}
	});
});

function animateBadges() {
  const containers = document.querySelectorAll('.cards-card-image, .prize-shortlist__box-head, .artist-about-image, .prize-artist__box-head');

  containers.forEach(container => {
    const flags = Array.from(container.querySelectorAll('.flag, .prize-shortlist__box-label, .prize-artist__box-label'));

    if (flags.length <= 1) {
      if (flags[0]) flags[0].classList.add('is-active');
      return;
    }

    let index = 0;

    flags[index].classList.add('is-active');

    setInterval(() => {
      flags[index].classList.remove('is-active');
      index = (index + 1) % flags.length;
      flags[index].classList.add('is-active');
    }, 3000);
  });
}

animateBadges();
